import { Chain } from './types'

export const FetchUris = [
    { value: '', label: 'None fetching' },
    {
        value: 'https://duckio-artifacts.s3.us-west-1.amazonaws.com/artifacts.json',
        label: 'Zksync Era',
    },
    {
        value: 'https://duckio-artifacts.s3.us-west-1.amazonaws.com/bera_artifacts.json',
        label: 'Berachain',
    },
]
export const SupportedChains: Chain = {
    '1': 'https://mainnet.infura.io/v3/${INFURA_API_KEY}',
    '2': 'https://node.expanse.tech',
    '3': 'https://ropsten.infura.io/v3/${INFURA_API_KEY}',
    '4': 'https://rinkeby.infura.io/v3/${INFURA_API_KEY}',
    '5': 'https://goerli.infura.io/v3/${INFURA_API_KEY}',
    '7': 'https://rpc.dome.cloud',
    '8': 'https://rpc.octano.dev',
    '10': 'https://mainnet.optimism.io',
    '11': 'https://api.metadium.com/prod',
    '12': 'https://api.metadium.com/dev',
    '13': 'https://staging.diode.io:8443/',
    '14': 'https://flare-api.flare.network/ext/C/rpc',
    '15': 'https://prenet.diode.io:8443/',
    '16': 'https://coston-api.flare.network/ext/C/rpc',
    '17': 'https://rpc.thaifi.com',
    '18': 'https://testnet-rpc.thundercore.com',
    '19': 'https://songbird-api.flare.network/ext/C/rpc',
    '20': 'https://api.elastos.io/eth',
    '21': 'https://api-testnet.elastos.io/eth',
    '24': 'https://rpc.kardiachain.io',
    '25': 'https://evm.cronos.org',
    '26': 'https://testrpc.genesisl1.org',
    '27': 'https://rpc.shibchain.org',
    '28': 'https://rinkeby.boba.network/',
    '29': 'https://rpc.genesisl1.org',
    '30': 'https://public-node.rsk.co',
    '31': 'https://public-node.testnet.rsk.co',
    '32': 'https://test2.goodata.io',
    '33': 'https://rpc.goodata.io',
    '34': 'https://mainnet-rpc.scai.network',
    '35': 'https://rpc.tbwg.io',
    '36': 'https://mainnet.dxchain.com',
    '37': 'https://dimension-evm-rpc.xpla.dev',
    '38': 'https://rpc.valorbit.com/v2',
    '39': 'https://rpc-mainnet.u2u.xyz',
    '40': 'https://mainnet.telos.net/evm',
    '41': 'https://testnet.telos.net/evm',
    '42': 'https://rpc.mainnet.lukso.network',
    '43': 'https://pangolin-rpc.darwinia.network',
    '44': 'https://crab-rpc.darwinia.network',
    '45': 'https://pangoro-rpc.darwinia.network',
    '46': 'https://rpc.darwinia.network',
    '47': 'https://aic.acria.ai',
    '48': 'https://rpc.etm.network',
    '49': 'https://rpc.pioneer.etm.network',
    '50': 'https://erpc.xinfin.network',
    '51': 'https://rpc.apothem.network',
    '52': 'https://rpc.coinex.net',
    '53': 'https://testnet-rpc.coinex.net/',
    '54': 'https://mainnet.openpiece.io',
    '55': 'https://rpc-1.zyx.network/',
    '56': 'https://bsc-dataseed1.bnbchain.org',
    '57': 'https://rpc.syscoin.org',
    '58': 'http://dappnode1.ont.io:20339',
    '59': 'https://api.eosargentina.io',
    '60': 'https://rpc.gochain.io',
    '61': 'https://etc.rivet.link',
    '63': 'https://rpc.mordor.etccooperative.org',
    '64': 'https://jsonrpc.ellaism.org',
    '65': 'https://exchaintestrpc.okex.org',
    '66': 'https://exchainrpc.okex.org',
    '67': 'http://test-rpc.dbmbp.com',
    '68': 'https://rpc.soter.one',
    '69': 'https://kovan.optimism.io/',
    '70': 'https://http-mainnet.hoosmartchain.com',
    '71': 'https://evmtestnet.confluxrpc.com',
    '72': 'https://testnet-http.dxchain.com',
    '73': 'https://fncy-seed1.fncy.world',
    '74': 'https://idchain.one/rpc/',
    '75': 'https://node.decimalchain.com/web3/',
    '76': 'https://rpc2.mix-blockchain.org:8647',
    '77': 'https://sokol.poa.network',
    '78': 'https://ethnode.primusmoney.com/mainnet',
    '79': 'https://dataserver-us-1.zenithchain.co/',
    '80': 'https://rpc.genechain.io',
    '81': 'https://rpc-1.japanopenchain.org:8545',
    '82': 'https://rpc.meter.io',
    '83': 'https://rpctest.meter.io',
    '84': 'https://linqto-dev.com',
    '85': 'https://testnet.gatenode.cc',
    '86': 'https://evm.gatenode.cc',
    '87': 'https://connect.novanetwork.io',
    '88': 'https://rpc.viction.xyz',
    '89': 'https://rpc-testnet.viction.xyz',
    '90': 'https://s0.garizon.net/rpc',
    '91': 'https://s1.garizon.net/rpc',
    '92': 'https://s2.garizon.net/rpc',
    '93': 'https://s3.garizon.net/rpc',
    '94': 'https://rpc.swissdlt.ch',
    '95': 'https://rpc1.camdl.gov.kh/',
    '96': 'https://rpc.bitkubchain.io',
    '97': 'https://data-seed-prebsc-1-s1.bnbchain.org:8545',
    '98': 'https://sixnet-rpc-evm.sixprotocol.net',
    '99': 'https://core.poa.network',
    '100': 'https://rpc.gnosischain.com',
    '101': 'https://api.einc.io/jsonrpc/mainnet',
    '102': 'https://testnet-rpc-0.web3games.org/evm',
    '103': 'https://seoul.worldland.foundation',
    '104': 'https://klc.live/',
    '105': 'https://devnet.web3games.org/evm',
    '106': 'https://evmexplorer.velas.com/rpc',
    '107': 'https://testnet.rpc.novanetwork.io',
    '108': 'https://mainnet-rpc.thundercore.com',
    '109': 'https://www.shibrpc.com',
    '110': 'https://protontestnet.greymass.com/',
    '111': 'https://rpc.etherlite.org',
    '112': 'https://coinbit-rpc-mainnet.chain.sbcrypto.app',
    '113': 'https://connect.dehvo.com',
    '114': 'https://coston2-api.flare.network/ext/C/rpc',
    '117': 'https://json-rpc.uptick.network',
    '118': 'https://testnet.arcology.network/rpc',
    '119': 'https://evmapi.nuls.io',
    '120': 'https://beta.evmapi.nuls.io',
    '121': 'https://rcl-dataseed1.rclsidechain.com',
    '122': 'https://rpc.fuse.io',
    '123': 'https://rpc.fusespark.io',
    '124': 'https://decentralized-web.tech/dw_rpc.php',
    '125': 'https://rpc.testnet.oychain.io',
    '126': 'https://rpc.mainnet.oychain.io',
    '128': 'https://http-mainnet.hecochain.com',
    '129': 'https://rpc.innovatorchain.com',
    '131': 'https://tokioswift.engram.tech',
    '132': 'https://rpc.chain.namefi.io',
    '133': 'https://hashkeychain-testnet.alt.technology',
    '134': 'https://bellecour.iex.ec',
    '135': 'https://testnet-rpc.alyxchain.com',
    '136': 'https://mainnet.deamchain.com',
    '137': 'https://polygon-rpc.com/',
    '138': 'https://rpc.defi-oracle.io',
    '139': 'https://rpc.woop.ai/rpc',
    '140': 'https://mainnet.eternalcoin.io/v1',
    '141': 'https://testnet.openpiece.io',
    '142': 'https://rpc.prodax.io',
    '144': 'https://connect.phi.network',
    '145': 'https://rpc-testnet.soraai.bot',
    '146': 'https://rpc.soniclabs.com',
    '147': 'https://mainnet-rpc.flagscan.xyz',
    '148': 'https://json-rpc.evm.shimmer.network',
    '150': 'https://rpc-evm.fivenet.sixprotocol.net',
    '151': 'https://governors.mainnet.redbelly.network',
    '153': 'https://governors.testnet.redbelly.network',
    '155': 'https://rpc.testnet.tenet.org',
    '156': 'https://testnet-rpc.oeblock.com',
    '157': 'https://puppynet.shibrpc.com',
    '158': 'https://dataseed.roburna.com',
    '159': 'https://preseed-testnet-1.roburna.com',
    '160': 'https://evascan.io/api/eth-rpc/',
    '161': 'https://testnet.evascan.io/api/eth-rpc/',
    '162': 'https://node.sirius.lightstreams.io',
    '163': 'https://node.mainnet.lightstreams.io',
    '164': 'https://omega.omni.network',
    '166': 'https://mainnet.omni.network',
    '167': 'https://node.atoshi.io/',
    '168': 'https://eth-dataseed.aioz.network',
    '169': 'https://pacific-rpc.manta.network/http',
    '170': 'https://http-testnet.hoosmartchain.com',
    '171': 'https://rpc.co2ledger.xyz',
    '172': 'https://rpc.latam-blockchain.com',
    '175': 'https://rpc.otc.run',
    '176': 'https://rpc.dcnetio.cloud',
    '177': 'https://mainnet.hsk.xyz',
    '178': 'https://testrpc.abeychain.com',
    '179': 'https://rpc.abeychain.com',
    '180': 'https://node1.amechain.io/',
    '181': 'https://rpc.waterfall.network/',
    '182': 'https://iost-mainnet.alt.technology',
    '183': 'https://mainnet.ethernitychain.io',
    '184': 'https://rpc-test-d11k.dojima.network',
    '185': 'https://rpc.mintchain.io',
    '186': 'https://rpc.seelen.pro/',
    '187': 'https://rpc-d11k.dojima.network',
    '188': 'https://mainnet.bmcchain.com/',
    '189': 'https://testnet.bmcchain.com',
    '190': 'https://bbqchain-rpc.commudao.xyz',
    '191': 'https://rpc.filefilego.com/rpc',
    '193': 'https://cemchain.com',
    '195': 'https://testrpc.xlayer.tech',
    '196': 'https://rpc.xlayer.tech',
    '197': 'https://testnet-rpc.neutrinoschain.com',
    '198': 'https://rpc.bitchain.biz/',
    '199': 'https://rpc.bt.io',
    '200': 'https://arbitrum.xdaichain.com/',
    '201': 'https://gateway.moac.io/testnet',
    '202': 'https://testnet.rpc.edgeless.network/http',
    '203': 'https://rpc.wowchain.io',
    '204': 'https://opbnb-mainnet-rpc.bnbchain.org',
    '205': 'https://mainnet.ekaash.biz',
    '206': 'https://vinufoundation-rpc.com',
    '207': 'https://vinuchain-rpc.com',
    '208': 'https://mainnet.structx.io',
    '210': 'https://rpc.bitnet.money',
    '211': 'http://13.57.207.168:3435',
    '212': 'https://testnet-rpc.maplabs.io',
    '213': 'https://hub-rpc.bsquared.network',
    '214': 'https://mainnet.shinarium.org',
    '216': 'https://happy-testnet-sepolia.rpc.caldera.xyz/http',
    '217': 'https://rpc2.siriusnet.io',
    '218': 'https://rpc.soter.one',
    '220': 'https://rpc-sepolia.scalind.com',
    '221': 'https://rpc.blockex.biz',
    '222': 'https://blockchain-api-mainnet.permission.io/rpc',
    '223': 'https://mainnet.b2-rpc.com',
    '224': 'https://testnet-rpc.vrd.network',
    '225': 'https://rpc-mainnet.lachain.io',
    '226': 'https://rpc-testnet.lachain.io',
    '227': 'https://prom-rpc.eu-north-2.gateway.fm',
    '228': 'https://rpc-mainnet.mindnetwork.xyz',
    '230': 'https://rpc.swapdex.network',
    '233': 'https://testnet.ethernitychain.io',
    '234': 'https://testnode.jumbochain.org',
    '236': 'https://testnet.deamchain.com',
    '238': 'https://rpc.blastblockchain.com',
    '240': 'https://testnet.zkevm.cronos.org',
    '242': 'https://rpcurl.mainnet.plgchain.com',
    '246': 'https://rpc.energyweb.org',
    '248': 'https://rpc.mainnet.oasys.games',
    '250': 'https://rpc.ftm.tools',
    '251': 'https://rpc-api.glideprotocol.xyz/l1-rpc/',
    '252': 'https://rpc.frax.com',
    '253': 'https://rpc-api.glideprotocol.xyz/l2-rpc/',
    '254': 'https://mainnet-rpc.swanchain.org',
    '255': 'https://api.kroma.network',
    '256': 'https://http-testnet.hecochain.com',
    '259': 'https://mainnet.neonlink.io',
    '260': 'https://rpc-main.gurunetwork.ai',
    '261': 'https://rpc-test.gurunetwork.ai',
    '262': 'https://sur.nilin.org',
    '267': 'https://rpc.ankr.com/neura_testnet',
    '269': 'https://hpbnode.com',
    '271': 'https://rpc.egonscan.com',
    '273': 'https://xr-one.calderachain.xyz/http',
    '274': 'https://rpc1.mainnet.lachain.network',
    '278': 'https://rpc_mainnet.xfair.ai',
    '279': 'https://rpc.bpxchain.cc',
    '280': 'https://testnet.era.zksync.dev',
    '282': 'https://deprecated.testnet.zkevm.cronos.org',
    '288': 'https://mainnet.boba.network',
    '291': 'https://rpc.orderly.network',
    '293': 'https://rpc.davinci.bz',
    '295': 'https://mainnet.hashio.io/api',
    '296': 'https://testnet.hashio.io/api',
    '297': 'https://previewnet.hashio.io/api',
    '300': 'https://sepolia.era.zksync.dev',
    '301': 'https://bobaopera.boba.network',
    '302': 'https://sepolia.rpc.zkcandy.io',
    '303': 'https://nc-rpc-test1.neurochain.io',
    '305': 'https://mainnet.zksats.io',
    '307': 'https://trpc.lovely.network',
    '308': 'https://rpc.furtheon.org',
    '309': 'https://rpc-testnet3.wyzthchain.org/',
    '311': 'https://mainapi.omaxray.com',
    '313': 'https://nc-rpc-prd1.neurochain.io',
    '314': 'https://api.node.glif.io/',
    '315': 'https://rpc.wemblockchain.com',
    '321': 'https://rpc-mainnet.kcc.network',
    '322': 'https://rpc-testnet.kcc.network',
    '323': 'https://rpc.cosvm.net',
    '324': 'https://mainnet.era.zksync.io',
    '325': 'https://rpc.grvt.io',
    '326': 'https://zkrpc.testnet.grvt.io',
    '332': 'https://testapi.omaxray.com',
    '333': 'https://mainnet.web3q.io:8545',
    '335': 'https://subnets.avax.network/defi-kingdoms/dfk-chain-testnet/rpc',
    '336': 'https://shiden.api.onfinality.io/public',
    '338': 'https://evm-t3.cronos.org',
    '345': 'https://rpc01.trias.one',
    '360': 'https://mainnet.shape.network',
    '361': 'https://eth-rpc-api.thetatoken.org/rpc',
    '363': 'https://eth-rpc-api-sapphire.thetatoken.org/rpc',
    '364': 'https://eth-rpc-api-amber.thetatoken.org/rpc',
    '365': 'https://eth-rpc-api-testnet.thetatoken.org/rpc',
    '369': 'https://rpc.pulsechain.com',
    '371': 'https://rpc-testnet.theconsta.com',
    '380': 'https://rpc.testnet.zkamoeba.com:4050/',
    '381': 'https://rpc.mainnet.zkamoeba.com/rpc',
    '385': 'https://rpc-bitfalls1.lisinski.online',
    '388': 'https://mainnet.zkevm.cronos.org',
    '395': 'https://rpc1.testnet.camdl.gov.kh/',
    '397': 'https://eth-rpc.mainnet.near.org',
    '398': 'https://eth-rpc.testnet.near.org',
    '399': 'https://rpc.nativ3.network',
    '400': 'https://testnet-rpc.hyperonchain.com',
    '401': 'https://node1.testnet.ozonechain.io',
    '404': 'https://rpc.syndr.com',
    '411': 'https://rpc.pepe-chain.vip',
    '416': 'https://rpc.sx.technology',
    '418': 'https://rpc.testnet.lachain.network',
    '420': 'https://goerli.optimism.io',
    '422': 'https://mainnet-rpc.vrd.network',
    '424': 'https://rpc.publicgoods.network',
    '425': 'https://stenix.network/pub',
    '426': 'https://rpc.twmcrypto.com/',
    '427': 'https://rpc.zeeth.io',
    '428': 'https://rpc.verse.gesoten.com/',
    '434': 'https://evm-rpc.mainnet.boyaa.network',
    '443': 'https://testnet.ten.xyz',
    '444': 'https://sepolia.synapseprotocol.com',
    '456': 'https://chain-rpc.arzio.co',
    '462': 'https://testnet-rpc.areon.network',
    '463': 'https://mainnet-rpc.areon.network',
    '466': 'https://rpc.appchain.xyz/http',
    '478': 'https://rpc.form.network/http',
    '480': 'https://worldchain-mainnet.g.alchemy.com/public',
    '499': 'https://rpc.rupaya.io',
    '500': 'https://api.camino.network/ext/bc/C/rpc',
    '501': 'https://columbus.camino.network/ext/bc/C/rpc',
    '510': 'https://rpc-mainnet.syndicate.io',
    '512': 'https://rpc.acuteangle.com',
    '513': 'https://rpc-testnet.acuteangle.com',
    '516': 'https://gzn.linksme.info',
    '520': 'https://datarpc1.xsc.pub',
    '529': 'https://rpc-mainnet.thefirechain.com',
    '530': 'https://fx-json-web3.functionx.io:8545',
    '534': 'https://candle-rpc.com/',
    '537': 'https://rpc.optrust.io',
    '542': 'https://pawchainx.com/',
    '545': 'https://testnet.evm.nodes.onflow.org',
    '550': 'https://mainnet.rpc.river.build',
    '555': 'https://rpc.velaverse.io',
    '558': 'https://rpc.testnet.tao.network',
    '565': 'https://explorer.testnet.prometheuz.io',
    '568': 'https://rpc-testnet.dogechain.dog',
    '570': 'https://rpc.rollux.com',
    '571': 'https://rpc.metatime.com',
    '579': 'https://rpc.filenova.org',
    '588': 'https://stardust.metis.io/?owner=588',
    '592': 'https://rpc.astar.network:8545',
    '595': 'https://eth-rpc-tc9.aca-staging.network',
    '596': 'https://eth-rpc-karura-testnet.aca-staging.network',
    '597': 'https://eth-rpc-acala-testnet.aca-staging.network',
    '599': 'https://goerli.gateway.metisdevops.link',
    '601': 'https://rpc-testnet.vne.network',
    '610': 'https://devnet-rpc.darwinchain.ai',
    '612': 'https://rpc.eiob.xyz',
    '614': 'https://glq-dataseed.graphlinq.io',
    '619': 'http://rpc.skynet.io',
    '624': 'https://rpc.zero.thebinaryholdings.com',
    '625': 'https://rpc.testnet.thebinaryholdings.com',
    '632': 'https://node.nfbchain.com',
    '634': 'https://rpc.avocado.instadapp.io',
    '646': 'https://previewnet.evm.nodes.onflow.org',
    '647': 'https://rpc.toronto.sx.technology',
    '648': 'https://rpc-endurance.fusionist.io/',
    '653': 'https://rpc.kalichain.com',
    '654': 'https://mainnet.kalichain.com',
    '662': 'https://rpc.ultronsmartchain.io',
    '666': 'https://http-testnet.chain.pixie.xyz',
    '667': 'https://arrakis.gorengine.com/own',
    '668': 'https://rpc.juncachain.com',
    '669': 'https://rpc-testnet.juncachain.com',
    '678': 'https://rpc.janction.io',
    '679': 'https://rpc_testnet.janction.io',
    '686': 'https://eth-rpc-karura.aca-api.network',
    '689': 'https://rpc-testnet.nerochain.io',
    '690': 'https://rpc.redstonechain.com',
    '698': 'https://rpc.matchain.io',
    '699': 'https://testnet-rpc.matchain.io',
    '700': 'https://avastar.cc/ext/bc/C/rpc',
    '701': 'https://koi-rpc.darwinia.network',
    '707': 'https://rpc-mainnet.bcsdev.io',
    '708': 'https://rpc-testnet.bcsdev.io',
    '710': 'https://highbury.furya.io',
    '711': 'https://evm-rpc.tucana.zone',
    '712': 'https://evm-rpc.birdee-2.tucana.zone',
    '713': 'https://rpc-mainnet-5.vrcscan.com',
    '718': 'https://rpc.uxlinkone.com',
    '719': 'https://puppynet.shibrpc.com',
    '721': 'https://rpc.lycanchain.com/',
    '727': 'https://data.bluchain.pro',
    '730': 'https://rpc.lovely.network',
    '740': 'https://eth.plexnode.wtf/',
    '741': 'https://node-testnet.vention.network',
    '742': 'https://testeth-rpc-api.script.tv/rpc',
    '743': 'https://tranched-mainnet.calderachain.xyz/http',
    '747': 'https://mainnet.evm.nodes.onflow.org',
    '753': 'https://rivalz.calderachain.xyz/http',
    '766': 'https://rpc.qom.one',
    '777': 'https://node.cheapeth.org/rpc',
    '785': 'https://testnet-rpc1.autheo.com',
    '786': 'https://node1-mainnet.maalscan.io/',
    '787': 'https://eth-rpc-acala.aca-api.network',
    '788': 'https://testnet-rpc.aerochain.id/',
    '789': 'https://rpc.patex.io/',
    '799': 'https://rpc.testnet.rupaya.io',
    '800': 'https://rpc.lucidcoin.io',
    '803': 'https://orig.haichain.io/',
    '805': 'https://rpc.evozscan.com',
    '808': 'https://subnets.avax.network/portal-fantasy/testnet/rpc',
    '810': 'https://testnet-rpc.haven1.org',
    '813': 'https://evm-dataseed1.meerscan.io',
    '814': 'https://rpc-zkevm.thefirechain.com',
    '818': 'https://dataseed1.beonechain.com',
    '820': 'https://rpc.callistodao.org',
    '822': 'https://rpc-testnet.runic.build',
    '824': 'https://rpc.mainnet.dailycrypto.net',
    '825': 'https://rpc.testnet.dailycrypto.net',
    '831': 'https://devnet.checkdot.io',
    '841': 'https://rpc.mainnet.taraxa.io/',
    '842': 'https://rpc.testnet.taraxa.io/',
    '852': 'https://eth.jegotrip.net',
    '859': 'https://rpc.dev.zeeth.io',
    '861': 'https://rpc.electranetwork.tech',
    '868': 'https://mainnet-data1.fantasiachain.com/',
    '871': 'https://rpc.testnet.electranetwork.tech',
    '876': 'https://rpc.main.oasvrs.bnken.net',
    '877': 'https://dxt.dexit.network',
    '880': 'https://api.ambros.network',
    '888': 'https://gwan-ssl.wandevs.org:56891/',
    '898': 'https://rpc-testnet.maxi.network',
    '899': 'https://rpc.maxi.network',
    '900': 'https://s0-testnet.garizon.net/rpc',
    '901': 'https://s1-testnet.garizon.net/rpc',
    '902': 'https://s2-testnet.garizon.net/rpc',
    '903': 'https://s3-testnet.garizon.net/rpc',
    '910': 'https://layer1test.decentrabone.com',
    '911': 'https://rpc.taprootchain.io',
    '917': 'https://rinia-rpc1.thefirechain.com',
    '918': 'https://rpc.slerfchain.xyz',
    '919': 'https://sepolia.mode.network',
    '927': 'https://rpc.yidark.io',
    '938': 'https://haust-network-rpc.eu-north-2.gateway.fm',
    '940': 'https://rpc.v2.testnet.pulsechain.com/',
    '941': 'https://rpc.v2b.testnet.pulsechain.com/',
    '942': 'https://rpc.v3.testnet.pulsechain.com/',
    '943': 'https://rpc.v4.testnet.pulsechain.com',
    '945': 'https://test.chain.opentensor.ai',
    '957': 'https://rpc.lyra.finance',
    '963': 'https://rpc.bitcoincode.technology/',
    '964': 'https://lite.chain.opentensor.ai',
    '969': 'https://rpc.ethxy.com',
    '970': 'https://mainnet-rpc.oortech.com',
    '972': 'https://ascraeus-rpc.oortech.com',
    '973': 'https://rpc.palmsmartchain.io',
    '977': 'https://api.nepalblockchain.dev',
    '979': 'https://rpc.testnet.ethxy.com',
    '980': 'https://ethapi.topnetwork.org',
    '985': 'https://chain.metamemo.one:8501',
    '987': 'https://rpc.binarychain.org',
    '990': 'https://rpc.eliberty.ngo',
    '995': 'https://rpc.5ire.network',
    '996': 'https://hk.p.bifrost-rpc.liebi.com',
    '997': 'https://rpc.testnet.5ire.network',
    '998': 'https://api.hyperliquid-testnet.xyz/evm',
    '999': 'https://gwan-ssl.wandevs.org:46891/',
    '1000': 'https://rpc.gton.network/',
    '1001': 'https://public-en-kairos.node.kaia.io',
    '1003': 'https://rpc.softnote.com/',
    '1004': 'https://test.ekta.io:8545',
    '1005': 'https://rpc.testnet.lemonchain.io',
    '1006': 'https://rpc.lemonchain.io',
    '1007': 'https://rpc1.newchain.newtonproject.org',
    '1008': 'https://mainnet.eurus.network/',
    '1009': 'https://rpcpriv.jumbochain.org',
    '1010': 'https://meta.evrice.com',
    '1011': 'https://apievm.rebuschain.com/rpc',
    '1012': 'https://global.rpc.mainnet.newtonproject.org',
    '1024': 'https://api-para.clover.finance',
    '1028': 'https://testrpc.bittorrentchain.io/',
    '1029': 'https://pre-rpc.bt.io',
    '1030': 'https://evm.confluxrpc.com',
    '1031': 'http://128.199.94.183:8041',
    '1038': 'https://evm-testnet.bronos.org',
    '1073': 'https://json-rpc.evm.testnet.shimmer.network',
    '1075': 'https://json-rpc.evm.testnet.iotaledger.net',
    '1079': 'https://subnets.avax.network/mintara/testnet/rpc',
    '1080': 'https://subnets.avax.network/mintara/mainnet/rpc',
    '1088': 'https://andromeda.metis.io/?owner=1088',
    '1089': 'https://jsonrpc.humans.nodestake.top',
    '1100': 'https://dymension-evm.blockpi.network/v1/rpc/public',
    '1101': 'https://zkevm-rpc.com',
    '1107': 'https://testnetq1.blx.org',
    '1108': 'https://mainnet.blxq.org',
    '1111': 'https://api.wemix.com',
    '1112': 'https://api.test.wemix.com',
    '1113': 'https://testnet-hub-rpc.bsquared.network',
    '1114': 'https://rpc.test2.btcs.network/',
    '1115': 'https://rpc.test.btcs.network/',
    '1116': 'https://rpc.coredao.org/',
    '1117': 'https://mainnet-rpc.dogcoin.me',
    '1123': 'https://b2-testnet.alt.technology',
    '1125': 'https://rpc-mainnet.taker.xyz',
    '1133': 'https://dmc.mydefichain.com/changi',
    '1135': 'https://rpc.api.lisk.com',
    '1138': 'https://testnet-rpc.amstarscan.com',
    '1139': 'https://mathchain-asia.maiziqianbao.net/rpc',
    '1140': 'https://galois-hk.maiziqianbao.net/rpc',
    '1147': 'https://testnet-rpc.flagscan.xyz',
    '1149': 'https://plex-rpc.plexfinance.us',
    '1170': 'https://json-rpc.origin.uptick.network',
    '1174': 'https://testnet.litheum.com',
    '1177': 'https://s2.tl.web.tr:4041',
    '1188': 'https://mainnet.mosscan.com',
    '1197': 'https://dataseed.iorachain.com',
    '1200': 'https://mainnet-rpc.cuckoo.network',
    '1201': 'https://seed5.evanesco.org:8547',
    '1202': 'https://rpc.cadaut.com',
    '1209': 'https://rpc-nodes.saitascan.io',
    '1210': 'https://testnet-rpc.cuckoo.network',
    '1212': 'https://testnet.adftechnology.com/',
    '1213': 'https://dataseed.popcateum.org',
    '1214': 'https://tapi.entercoin.net/',
    '1215': 'https://mainnet.adftechnology.com/',
    '1221': 'https://rpc-testnet.cyclenetwork.io',
    '1223': 'https://jellyfish-rpc-testnet.cyclenetwork.io',
    '1224': 'https://testnet-rpc.buildonhybrid.com',
    '1225': 'https://hybrid-testnet.rpc.caldera.xyz/http',
    '1227': 'https://testnet-chain.btcprotocol.io/',
    '1228': 'https://cuttlefish-rpc-testnet.cyclenetwork.io',
    '1229': 'https://mainnet.exzo.technology',
    '1230': 'https://ultron-dev.io',
    '1231': 'https://ultron-rpc.net',
    '1234': 'https://rpc.step.network',
    '1235': 'https://rpc.itxchain.com',
    '1243': 'https://rpc-main-1.archiechain.io',
    '1244': 'https://rpc-test-1.archiechain.io',
    '1246': 'https://rpc-cnx.omplatform.com/',
    '1248': 'https://rpc.dogether.dog/',
    '1252': 'https://testapi.cicscan.com',
    '1260': 'https://tapi.accesscan.io',
    '1280': 'https://nodes.halo.land',
    '1284': 'https://rpc.api.moonbeam.network',
    '1285': 'https://rpc.api.moonriver.moonbeam.network',
    '1287': 'https://rpc.api.moonbase.moonbeam.network',
    '1288': 'https://rpc.api.moonrock.moonbeam.network',
    '1291': 'https://json-rpc.testnet.swisstronik.com',
    '1294': 'https://bobabeam.boba.network',
    '1297': 'https://bobabase.boba.network',
    '1298': 'https://rpc-testnet.devolvedai.com',
    '1299': 'https://rpc.devolvedai.com',
    '1300': 'https://rpc.glue.net',
    '1301': 'https://sepolia.unichain.org',
    '1311': 'https://test.doschain.com/jsonrpc',
    '1313': 'https://rpc.jaihochain.com',
    '1314': 'https://rpc.alyxchain.com',
    '1315': 'https://devnet.storyrpc.io.',
    '1319': 'https://aia-dataseed1.aiachain.org',
    '1320': 'https://aia-dataseed1-testnet.aiachain.org',
    '1328': 'https://evm-rpc-testnet.sei-apis.com',
    '1329': 'https://evm-rpc.sei-apis.com',
    '1337': 'http://127.0.0.1:8545',
    '1338': 'https://rpc.atlantischain.network',
    '1339': 'https://rpc.elysiumchain.tech',
    '1343': 'https://subnets.avax.network/blitz/testnet/rpc',
    '1353': 'https://xapi.cicscan.com',
    '1369': 'https://mainnet.zakumi.io',
    '1370': 'https://blockchain.ramestta.com',
    '1377': 'https://testnet.ramestta.com',
    '1379': 'https://rpc-api.kalarchain.tech',
    '1388': 'https://mainnet-rpc.amstarscan.com',
    '1392': 'https://rpc.modchain.net/blockchain.joseon.com/rpc',
    '1433': 'https://rpc.rikscan.com',
    '1440': 'https://beta.mainnet.livingassets.io/rpc',
    '1442': 'https://rpc.public.zkevm-test.net',
    '1452': 'https://rpc.giltestnet.com',
    '1453': 'https://istanbul-rpc.metachain.dev',
    '1455': 'https://mainnet-rpc.ctexscan.com/',
    '1456': 'https://mainnet-rpc.zkbase.app',
    '1480': 'https://rpc.vana.org/',
    '1490': 'https://rpc.vitruveo.xyz',
    '1499': 'https://rpc-testnet.idos.games',
    '1501': 'https://rpc-canary-1.bevm.io/',
    '1506': 'https://mainnet.sherpax.io/rpc',
    '1507': 'https://sherpax-testnet.chainx.org/rpc',
    '1513': 'https://testnet.storyrpc.io',
    '1514': 'https://mainnet.storyrpc.io',
    '1515': 'https://beagle.chat/eth',
    '1516': 'https://odyssey.storyrpc.io',
    '1555': 'https://rpc01.dscscan.io',
    '1559': 'https://rpc.tenet.org',
    '1570': 'https://testnet-rpc1.starworksglobal.com',
    '1578': 'https://rpc.starworksglobal.com',
    '1605': 'https://rpc.bethscan.io',
    '1617': 'https://rpc.etins.org',
    '1618': 'https://send.catechain.com',
    '1620': 'https://rpc.atheios.org/',
    '1625': 'https://rpc.gravity.xyz',
    '1648': 'https://mainnet.pivotalprotocol.com',
    '1657': 'https://dataseed1.btachain.com/',
    '1663': 'https://gobi-rpc.horizenlabs.io/ethv1',
    '1686': 'https://testnet-rpc.mintchain.io',
    '1687': 'https://sepolia-testnet-rpc.mintchain.io',
    '1688': 'https://rpc.ludan.org/',
    '1689': 'https://rpc.nerochain.io',
    '1701': 'https://geth.anytype.io',
    '1707': 'https://rpc.blockchain.or.th',
    '1708': 'https://rpc.testnet.blockchain.or.th',
    '1717': 'https://mainnet.doric.network',
    '1718': 'https://palette-rpc.com:22000',
    '1729': 'https://rpc.reya.network',
    '1740': 'https://testnet.rpc.metall2.com',
    '1750': 'https://rpc.metall2.com',
    '1773': 'https://tea.mining4people.com/rpc',
    '1777': 'https://rpc.gaussgang.com',
    '1789': 'https://sepolia-rpc.zkbase.app',
    '1804': 'https://cacib-saturn-test.francecentral.cloudapp.azure.com',
    '1807': 'https://rabbit.analog-rpc.com',
    '1811': 'https://testnet-evm.lif3.com',
    '1818': 'https://http-mainnet.cube.network',
    '1819': 'https://http-testnet.cube.network',
    '1821': 'https://mainnet-data.rubychain.io/',
    '1829': 'https://rpc.playblock.io',
    '1833': 'https://rpc.verify-testnet.gelato.digital',
    '1853': 'https://subnets.avax.network/highoctane/mainnet/rpc',
    '1856': 'https://tsfapi.europool.me',
    '1868': 'https://rpc.soneium.org',
    '1875': 'https://rpc.whitechain.io',
    '1881': 'https://rpc.cartenz.works',
    '1890': 'https://replicator.phoenix.lightlink.io/rpc/v1',
    '1891': 'https://replicator.pegasus.lightlink.io/rpc/v1',
    '1898': 'http://rpc.boyanet.org:8545',
    '1899': 'https://layer2.redefi.world',
    '1904': 'https://rpc.sportschainnetwork.xyz/',
    '1907': 'https://rpc.bitci.com',
    '1908': 'https://testnet.bitcichain.com',
    '1909': 'https://marklechain-rpc.merklescan.com',
    '1911': 'https://rpc.scalind.com',
    '1912': 'https://testnet-rchain.rubychain.io/',
    '1918': 'https://testnet.crescdi.pub.ro',
    '1923': 'https://swell-mainnet.alt.technology',
    '1924': 'https://swell-testnet.alt.technology',
    '1927': 'https://rpc-testnet-market.arvix.network',
    '1945': 'https://rpc-testnet.onuschain.io',
    '1946': 'https://rpc.minato.soneium.org',
    '1949': 'https://testnet-chain.bionixnetwork.com',
    '1951': 'https://mainnet.d-chain.network/ext/bc/2ZiR1Bro5E59siVuwdNuRFzqL95NkvkbzyLBdrsYR9BLSHV7H4/rpc',
    '1953': 'https://rpc-testnet.selendra.org',
    '1954': 'https://rpc.dexilla.com',
    '1956': 'https://rpc-testnet.aiw3.io/',
    '1961': 'https://rpc.selendra.org',
    '1967': 'https://rpc.metatime.com/eleanor',
    '1969': 'https://testnetrpc.scschain.com',
    '1970': 'https://rpc.scschain.com',
    '1971': 'https://1971.network/atlr',
    '1972': 'https://rpc2.redecoin.eu',
    '1975': 'https://rpc.onuschain.io',
    '1984': 'https://testnet.eurus.network',
    '1985': 'http://rpc.satosh.ie',
    '1986': 'http://testnet.satosh.ie',
    '1987': 'https://jsonrpc.egem.io/custom',
    '1992': 'https://rpc.hubble.exchange',
    '1993': 'https://sepolia.b3.fun',
    '1994': 'https://main.ekta.io',
    '1995': 'https://testnet.edexa.network/rpc',
    '1996': 'https://mainnet.sanko.xyz',
    '1997': 'https://rpc.kyotochain.io',
    '1998': 'https://rpc.testnet.kyotoprotocol.io:8545',
    '2000': 'https://rpc.dogechain.dog',
    '2001': 'https://rpc-mainnet-cardano-evm.c1.milkomeda.com',
    '2002': 'https://rpc-mainnet-algorand-rollup.a1.milkomeda.com',
    '2004': 'http://77.237.237.69:9933',
    '2013': 'https://polytopia.org:8545',
    '2014': 'https://rpc-testnet.nowscan.io',
    '2016': 'https://mainnet-rpc.mainnetz.io',
    '2017': 'https://rpc.telcoin.network',
    '2018': 'https://rpc.dev.publicmint.io:8545',
    '2019': 'https://rpc.tst.publicmint.io:8545',
    '2020': 'https://api.roninchain.com/rpc',
    '2021': 'https://edgeware-evm.jelliedowl.net',
    '2022': 'https://beresheet-evm.jelliedowl.net',
    '2023': 'https://test-taycan.hupayx.io',
    '2024': 'https://saturn-rpc.swanchain.io',
    '2025': 'https://mainnet.rangersprotocol.com/api/jsonrpc',
    '2026': 'https://rpc.edgeless.network/http',
    '2031': 'https://fullnode.centrifuge.io',
    '2032': 'wss://fullnode.catalyst.cntrfg.com',
    '2037': 'https://subnets.avax.network/kiwi/testnet/rpc',
    '2038': 'https://subnets.avax.network/shrapnel/testnet/rpc',
    '2039': 'https://rpc.alephzero-testnet.gelato.digital',
    '2040': 'https://rpc.vanarchain.com',
    '2043': 'https://astrosat.origintrail.network',
    '2044': 'https://subnets.avax.network/shrapnel/mainnet/rpc',
    '2047': 'https://web3-rpc-mesos.thestratos.org',
    '2048': 'https://web3-rpc.thestratos.org',
    '2049': 'https://msc-rpc.movoscan.com',
    '2071': 'https://oli.accesscan.io',
    '2077': 'https://rpc.qkacoin.org',
    '2088': 'wss://fullnode.altair.centrifuge.io',
    '2089': 'wss://fullnode.algol.cntrfg.com',
    '2100': 'https://api.ecoball.org/ecoball/',
    '2101': 'https://api.ecoball.org/espuma/',
    '2109': 'https://rpc.exosama.com',
    '2112': 'https://rpc.uchain.link/',
    '2121': 'https://rpc1.catenarpc.com',
    '2122': 'https://rpc.metaplayer.one/',
    '2124': 'https://rpc-dubai.mp1network.com/',
    '2136': 'https://test-market.bigsb.network',
    '2137': 'https://market.bigsb.io',
    '2138': 'https://rpc.public-2138.defi-oracle.io',
    '2140': 'https://rpc.onenesslabs.io/',
    '2141': 'https://rpc.testnet.onenesslabs.io/',
    '2151': 'https://mainnet.bosagora.org',
    '2152': 'https://rpc-mainnet.findora.org',
    '2153': 'https://prod-testnet.prod.findora.org:8545/',
    '2154': 'https://prod-forge.prod.findora.org:8545/',
    '2162': 'https://rpc.kanda.animechain.ai',
    '2187': 'https://mainnet-rpc.game7.io',
    '2192': 'https://mainnet.snaxchain.io',
    '2199': 'https://rpc.moonsama.com',
    '2202': 'https://rpc.antofy.io',
    '2203': 'https://connect.bitcoinevm.com',
    '2213': 'https://seed4.evanesco.org:8546',
    '2221': 'https://evm.testnet.kava.io',
    '2222': 'https://evm.kava.io',
    '2223': 'https://bc.vcex.xyz',
    '2241': 'https://erpc-krest.peaq.network',
    '2300': 'https://rpc.bombchain.com',
    '2306': 'https://greendinoswap.com',
    '2310': 'https://node1.cratd2csmartchain.io',
    '2311': 'https://vesuvius-rpc.litprotocol.com',
    '2323': 'https://data-testnet-v1.somanetwork.io/',
    '2330': 'https://rpc0.altcoinchain.org/rpc',
    '2331': 'https://rpc.testnet.rss3.io',
    '2332': 'https://data-mainnet-v1.somanetwork.io/',
    '2340': 'wss://testnet-rpc.atleta.network:9944',
    '2342': 'https://rpc.omniaverse.io',
    '2345': 'https://rpc.goat.network',
    '2355': 'https://rpc.silicon.network',
    '2357': 'https://api.sepolia-deprecated.kroma.network',
    '2358': 'https://api.sepolia.kroma.network',
    '2368': 'https://rpc-testnet.gokite.ai',
    '2370': 'https://evm-testnet.nexis.network',
    '2390': 'https://turin.rpc.tac.build',
    '2399': 'https://bombchain-testnet.ankr.com/bas_full_rpc_1',
    '2400': 'https://rpc.tcgverse.xyz',
    '2410': 'https://rpc.karak.network',
    '2415': 'https://mainnet.xo-dex.com/rpc',
    '2420': 'https://rufus.calderachain.xyz/http',
    '2424': 'https://testnet.rpc.inevm.com/http',
    '2425': 'https://rpc-mainnet.kinggamer.org/',
    '2442': 'https://rpc.cardona.zkevm-rpc.com',
    '2458': 'https://rpc-testnet.hybridchain.ai/',
    '2468': 'https://coredata-mainnet.hybridchain.ai/',
    '2477': 'https://rpc.6do.world',
    '2484': 'https://rpc-nebulas-testnet.uniultra.xyz',
    '2488': 'https://rpc.nowscan.io',
    '2511': 'https://goerli.node1.karak.network',
    '2522': 'https://rpc.testnet.frax.com',
    '2525': 'https://mainnet.rpc.inevm.com/http',
    '2552': 'https://horizon-fastex-testnet.zeeve.net',
    '2559': 'https://www.kortho-chain.com',
    '2569': 'https://api.techpay.io/',
    '2606': 'https://pocrnet.westeurope.cloudapp.azure.com/http',
    '2611': 'https://dataseed2.redlightscan.finance',
    '2612': 'https://api.ezchain.com/ext/bc/C/rpc',
    '2613': 'https://testnet-api.ezchain.com/ext/bc/C/rpc',
    '2625': 'https://rpc-testnet.whitechain.io',
    '2648': 'https://testnet-rpc.ailayer.xyz',
    '2649': 'https://mainnet-rpc.ailayer.xyz',
    '2710': 'https://rpc-testnet.morphl2.io',
    '2718': 'https://rpc.klaos.laosfoundation.io',
    '2730': 'https://xr-sepolia-testnet.rpc.caldera.xyz/http',
    '2731': 'https://testnet-rpc.timenetwork.io',
    '2741': 'https://api.mainnet.abs.xyz',
    '2748': 'https://rpc.nanon.network',
    '2777': 'https://rpc.gmnetwork.ai',
    '2810': 'https://rpc-quicknode-holesky.morphl2.io',
    '2818': 'https://rpc.morphl2.io',
    '2882': 'https://node.chips.ooo/wasp/api/v1/chains/iota1pp3d3mnap3ufmgqnjsnw344sqmf5svjh26y2khnmc89sv6788y3r207a8fn/evm',
    '2888': 'https://goerli.boba.network/',
    '2889': 'https://aarmarpc.com/',
    '2907': 'https://rpc.eluxscan.com',
    '2911': 'https://rpc.hychain.com/http',
    '2941': 'https://testnet-chain.xenonchain.com/',
    '2999': 'https://mainnet.bityuan.com/eth',
    '3001': 'https://nikau.centrality.me/public',
    '3003': 'https://rpc.canxium.org',
    '3011': 'https://api.mainnet.playa3ull.games',
    '3030': 'https://mainapi.bchscan.io',
    '3031': 'https://rpc-testnet.orlchain.com',
    '3033': 'https://testnet.rebus.money/rpc',
    '3068': 'https://public-01.mainnet.bifrostnetwork.com/rpc',
    '3084': 'https://subnets.avax.network/xlnetworkt/testnet/rpc',
    '3100': 'https://fraa-flashbox-2800-rpc.a.stagenet.tanssi.network',
    '3102': 'https://fraa-dancebox-3050-rpc.a.dancebox.tanssi.network',
    '3109': 'https://alpha-rpc-node-http.svmscan.io',
    '3110': 'https://test-rpc-node-http.svmscan.io',
    '3269': 'https://rpcmain.arabianchain.org',
    '3270': 'https://rpctestnet.arabianchain.org',
    '3306': 'https://dev-rpc.debounce.network',
    '3331': 'https://rpc-testnet.zcore.cash',
    '3332': 'http://mainnet.l2.ethstorage.io:9540',
    '3333': 'http://testnet.ethstorage.io:9540',
    '3334': 'https://galileo.web3q.io:8545',
    '3335': 'http://devnet.l2.ethstorage.io:9540',
    '3336': 'http://testnet.l2.ethstorage.io:9540',
    '3337': 'http://devnet.ethstorage.io:9540',
    '3338': 'https://peaq.api.onfinality.io/public',
    '3339': 'http://mainnet.ethstorage.io:9540',
    '3366': 'https://mainnet-node1.meronscan.ai/',
    '3369': 'https://testnet-node1.meronscan.ai/',
    '3400': 'https://rpc.paribu.network',
    '3424': 'https://rpc.evoexplorer.com',
    '3434': 'https://testnet-rpc.securechain.ai',
    '3456': 'https://testnet-rpc.layeredge.io',
    '3490': 'https://gtc-dataseed.gtcscan.io/',
    '3500': 'https://rpc.testnet.paribuscan.com',
    '3501': 'https://rpc.jfinchain.com',
    '3502': 'https://rpc.jfinpos.com',
    '3601': 'https://eth-rpc-api.pandoproject.org/rpc',
    '3602': 'https://testnet.ethrpc.pandoproject.org/rpc',
    '3630': 'https://mainnet-rpc.tycoscan.com',
    '3636': 'https://node.botanixlabs.dev',
    '3637': 'https://rpc.btxtestchain.com',
    '3639': 'https://rpc.ichainscan.com',
    '3645': 'https://istanbul.ichainscan.com',
    '3666': 'https://rpc.jnsdao.com:8503',
    '3690': 'https://rpc1.bittexscan.info',
    '3693': 'https://rpc.empirenetwork.io',
    '3698': 'https://testnet-rpc.senjepowersscan.com',
    '3699': 'https://rpc.senjepowersscan.com',
    '3701': 'https://dimension-rpc.xpla.dev',
    '3737': 'https://rpc.crossbell.io',
    '3776': 'https://rpc.startale.com/astar-zkevm',
    '3797': 'https://elves-core1.alvey.io',
    '3799': 'https://testnet-rpc.tangle.tools',
    '3885': 'https://rpc-zkevm-ghostrider.thefirechain.com',
    '3888': 'https://rpc.kalychain.io/rpc',
    '3889': 'https://testnetrpc.kalychain.io/rpc',
    '3912': 'https://www.dracscan.com/rpc',
    '3939': 'https://test.doschain.com/',
    '3966': 'https://api.dynoprotocol.com',
    '3967': 'https://tapi.dynoprotocol.com',
    '3969': 'https://rpc.paynetwork.io',
    '3993': 'https://rpc-testnet.apexlayer.xyz',
    '3999': 'https://mainnet.yuan.org/eth',
    '4000': 'https://node1.ozonechain.io',
    '4001': 'https://rpc-testnet.peperium.io',
    '4002': 'https://rpc.testnet.fantom.network',
    '4003': 'https://x1-fastnet.xen.network',
    '4040': 'https://rpc-dev.carbonium.network/',
    '4048': 'https://rpc.gpu.net',
    '4051': 'https://testnet.bobaopera.boba.network',
    '4058': 'https://rpc1.ocean.bahamutchain.com',
    '4061': 'https://rpc.n3.nahmii.io',
    '4062': 'https://rpc.testnet.nahmii.io',
    '4078': 'https://muster.alt.technology',
    '4080': 'https://rpc-testnet.tobescan.com',
    '4088': 'https://my.zeroth.run',
    '4090': 'https://rpc1.oasis.bahamutchain.com',
    '4096': 'https://testnet-rpc.bitindi.org',
    '4099': 'https://mainnet-rpc.bitindi.org',
    '4102': 'https://eth-ds.testnet.aioz.network',
    '4139': 'https://evm-rpc.testnet.humans.zone',
    '4141': 'https://testnet-rpc.tipboxcoin.net',
    '4157': 'https://rpc.testnet.ms',
    '4158': 'https://rpc.mainnet.ms/',
    '4162': 'https://rpc.sx-rollup.gelato.digital',
    '4181': 'https://rpc1.phi.network',
    '4200': 'https://rpc.merlinchain.io',
    '4201': 'https://rpc.testnet.lukso.network',
    '4202': 'https://rpc.sepolia-api.lisk.com',
    '4242': 'https://rpc.chain.nexi.technology/',
    '4243': 'https://chain.nexiv2.nexilix.com',
    '4269': 'https://testnetrpc1.laikachain.dog',
    '4321': 'https://rpc-echos-mainnet-0.t.conduit.xyz',
    '4328': 'https://testnet.avax.boba.network',
    '4337': 'https://build.onbeam.com/rpc',
    '4400': 'https://rpc.creditsmartchain.com',
    '4422': 'https://testnet-rpc1.pikascan.com',
    '4444': 'https://janus.htmlcoin.com/api/',
    '4460': 'https://testnet-rpc.orderly.org',
    '4488': 'https://rpc-mainnet.hydrachain.org',
    '4544': 'https://testnet.emoney.network/',
    '4545': 'https://rpc-publicnode.emoney.io/',
    '4613': 'https://rpc.verylabs.io',
    '4646': 'https://mariorpc.mstblockchain.com',
    '4653': 'https://chain-rpc.gold.dev',
    '4661': 'https://appchaintestnet.rpc.caldera.xyz/http',
    '4689': 'https://babel-api.mainnet.iotex.io',
    '4690': 'https://babel-api.testnet.iotex.io',
    '4759': 'https://rpc.meversetestnet.io',
    '4777': 'https://testnet.blackfort.network/rpc',
    '4786': 'https://rpc-testnet.evnode.org/',
    '4801': 'https://worldchain-sepolia.g.alchemy.com/public',
    '4893': 'https://rpc.gcscan.io',
    '4913': 'https://oev.rpc.api3.org',
    '4918': 'https://rpc-evm-testnet.venidium.io',
    '4919': 'https://rpc.venidium.io',
    '4999': 'https://mainnet.blackfort.network/rpc',
    '5000': 'https://rpc.mantle.xyz',
    '5001': 'https://rpc.testnet.mantle.xyz',
    '5002': 'https://node0.treasurenet.io',
    '5003': 'https://rpc.sepolia.mantle.xyz',
    '5005': 'https://node0.testnet.treasurenet.io',
    '5039': 'https://subnets.avax.network/onigiri/testnet/rpc',
    '5040': 'https://subnets.avax.network/onigiri/mainnet/rpc',
    '5050': 'https://rpc.skatechain.org/',
    '5051': 'https://nollie-rpc.skatechain.org/',
    '5080': 'https://rpc.zeroscan.org',
    '5090': 'https://rpc.pionescan.com',
    '5100': 'https://rpc-testnet.syndicate.io',
    '5101': 'https://rpc-frame.syndicate.io',
    '5102': 'https://rpc-sic-testnet-zvr7tlkzsi.t.conduit.xyz',
    '5103': 'https://rpc-coordinape-testnet-vs9se3oc4v.t.conduit.xyz',
    '5104': 'https://rpc-charmverse-testnet-g6blnaebes.t.conduit.xyz',
    '5105': 'https://rpc-superloyalty-testnet-1m5gwjbsv1.t.conduit.xyz',
    '5106': 'https://rpc-azra-testnet-6hz86owb1n.t.conduit.xyz',
    '5112': 'https://rpc.ham.fun',
    '5115': 'https://rpc.testnet.citrea.xyz',
    '5151': 'https://testnet-rpc.mechain.tech',
    '5165': 'https://rpc1.bahamut.io',
    '5169': 'https://rpc.main.smartlayer.network',
    '5177': 'https://mainnet-rpc.tlxscan.com/',
    '5197': 'https://mainnet.eraswap.network',
    '5234': 'https://explorer-rpc-http.mainnet.stages.humanode.io',
    '5290': 'https://mainnet.rpc1.thefirechain.com',
    '5315': 'https://network.uzmigames.com.br/',
    '5317': 'https://rpctest.optrust.io',
    '5321': 'https://rpc.testnet.itxchain.com',
    '5330': 'https://mainnet.superseed.xyz',
    '5333': 'https://rpc1.netsbo.io',
    '5353': 'https://nodetestnet-station-one.tritanium.network/',
    '5373': 'https://settlus-septestnet.g.alchemy.com/public',
    '5424': 'https://mainnet.edexa.network/rpc',
    '5439': 'https://mainnet.egochain.org',
    '5464': 'http://sagaevm-5464-1.jsonrpc.sagarpc.io',
    '5511': 'https://rpc-mainnet.pointpay.io',
    '5522': 'https://testnet.vexascan.com/evmapi',
    '5545': 'https://rpc.duckchain.io',
    '5551': 'https://l2.nahmii.io',
    '5553': 'https://l2.testnet.nahmii.io',
    '5555': 'https://rpc.chainverse.info',
    '5611': 'https://opbnb-testnet-rpc.bnbchain.org',
    '5615': 'https://rpc-testnet.arcturuschain.io/',
    '5616': 'http://185.99.196.3:8545',
    '5656': 'https://rpc-main1.qiblockchain.online/',
    '5675': 'https://rpctest.filenova.org',
    '5678': 'https://fraa-dancebox-3001-rpc.a.dancebox.tanssi.network',
    '5700': 'https://rpc.tanenbaum.io',
    '5729': 'https://rpc-testnet.hika.network/',
    '5758': 'https://testnet-rpc.satoshichain.io',
    '5777': 'https://127.0.0.1:7545',
    '5845': 'https://rpc.tangle.tools',
    '5851': 'http://polaris1.ont.io:20339',
    '5858': 'https://rpc.cthscan.com/',
    '5869': 'https://proxy.wegochain.io',
    '6000': 'https://fullnode-testnet.bouncebitapi.com/',
    '6001': 'https://fullnode-mainnet.bouncebitapi.com/',
    '6060': 'https://rpc.bchscan.io',
    '6065': 'https://rpc-test.tresleches.finance/',
    '6066': 'https://rpc.tresleches.finance/',
    '6102': 'https://testnet.cascadia.foundation',
    '6118': 'https://node-api.alp.uptn.io/v1/ext/rpc',
    '6119': 'https://node-api.uptn.io/v1/ext/rpc',
    '6278': 'https://mainnet.steamexchange.io',
    '6283': 'https://rpc.laos.laosfoundation.io',
    '6320': 'https://testnet-node.nfbchain.com',
    '6321': 'https://jsonrpc.euphoria.aura.network',
    '6322': 'https://jsonrpc.aura.network',
    '6363': 'https://dsc-rpc.digitsoul.co.th',
    '6398': 'https://rpc.connext-sepolia.gelato.digital/',
    '6502': 'https://peerpay.su.gy/p2p',
    '6550': 'https://testnetrpc.flamma.network',
    '6552': 'https://testnet-rpc.scolcoin.com',
    '6565': 'https://rpc-testnet-v1.foxchain.app/',
    '6626': 'https://http-mainnet.chain.pixie.xyz',
    '6660': 'https://testnet-rpc.latestcoin.io',
    '6661': 'https://rpc-mainnet.cybria.io',
    '6666': 'https://l2-rpc.cybascan.io',
    '6667': 'https://rpc.storchain.io',
    '6678': 'https://rpc1-mainnet.emc.network',
    '6688': 'https://evmrpc.irishub-1.irisnet.org',
    '6699': 'https://rpc.oxscan.io',
    '6701': 'https://chain.paxb.io',
    '6779': 'https://rpc.compverse.io/',
    '6789': 'https://rpc-mainnet.goldsmartchain.com',
    '6805': 'https://racemainnet.io/',
    '6806': 'https://racetestnet.io/',
    '6868': 'https://rpc.poolsmobility.com',
    '6880': 'https://evm-rpc.mtt.network',
    '6900': 'https://evm-rpc.nibiru.fi',
    '6934': 'https://xyl-testnet.glitch.me/rpc/',
    '6942': 'https://mainnetrpc.laikachain.dog',
    '6969': 'https://rpc.tombchain.com/',
    '6999': 'https://seed0.polysmartchain.com/',
    '7000': 'https://zetachain-evm.blockpi.network/v1/rpc/public',
    '7001': 'https://zetachain-athens-evm.blockpi.network/v1/rpc/public',
    '7007': 'https://rpc.bstchain.io/',
    '7027': 'https://rpc.ella.network',
    '7070': 'https://evm-rpc.planq.network',
    '7077': 'https://evm-rpc-atlas.planq.network',
    '7099': 'https://bbnrpc.testnet.bharatblockchain.io',
    '7100': 'https://rpc.numecrypto.com',
    '7117': 'https://rpc.0xl3.com',
    '7171': 'https://connect.bit-rock.io',
    '7181': 'https://rpc-sepolia.uxlinkone.com',
    '7200': 'https://evm.exsat.network',
    '7208': 'https://rpc.nexera.network',
    '7210': 'https://evm-rpc.testnet-1.nibiru.fi',
    '7222': 'https://evm-rpc.devnet-3.nibiru.fi',
    '7233': 'https://rpc-mainnet.inichain.com',
    '7234': 'http://rpc-testnet.inichain.com',
    '7244': 'https://testnet-rpc.zeuschainscan.io',
    '7300': 'https://rpc-xpla-verse.xpla.dev',
    '7331': 'https://evm.klyntar.org/kly_evm_rpc',
    '7332': 'https://eon-rpc.horizenlabs.io/ethv1',
    '7341': 'https://rpc.shyft.network/',
    '7484': 'https://rpc.x.raba.app/',
    '7518': 'https://rpc.meversemainnet.io',
    '7560': 'https://cyber.alt.technology/',
    '7575': 'https://testnet.adilchain-rpc.io',
    '7576': 'https://adilchain-rpc.io',
    '7668': 'https://root.rootnet.live/archive',
    '7672': 'https://porcini.rootnet.app/archive',
    '7700': 'https://canto.slingshot.finance',
    '7701': 'https://testnet-archive.plexnode.wtf',
    '7744': 'https://testnet.phron.ai',
    '7770': 'https://rpc.testnet.pandasea.io',
    '7771': 'https://testnet.bit-rock.io',
    '7774': 'https://mainnet-rpc-1.gdccscan.io',
    '7775': 'https://testnet-rpc1.gdccscan.io',
    '7776': 'https://rpc1.pandasea.io',
    '7777': 'https://testnet1.riseofthewarbots.com',
    '7778': 'https://validator-mainnet.orenium.org',
    '7798': 'https://long.rpc.openex.network/',
    '7860': 'https://node1.maalscan.io/',
    '7862': 'https://node1-mainnet-new.maalscan.io/',
    '7863': 'https://node-testnet.maalscan.io/',
    '7865': 'https://rpc.powerloom.network',
    '7878': 'https://hatlas.rpc.hazlor.com:8545',
    '7879': 'https://rpc-testnet-asia1.vexonhub.org',
    '7887': 'https://rpc.kinto.xyz/http',
    '7895': 'https://rpc-athena.ardescan.com/',
    '7897': 'https://rpc.arena-z.gg',
    '7923': 'https://rpc.dotblox.io',
    '7924': 'https://mainnet-rpc.mochain.app/',
    '7957': 'https://rpc-1-testnet.exorium.net',
    '7979': 'https://main.doschain.com',
    '8000': 'https://evm-rpc.teleport.network',
    '8001': 'https://evm-rpc.testnet.teleport.network',
    '8008': 'https://rpc.polynomial.fi',
    '8017': 'https://mainnet.isuncoin.com',
    '8029': 'https://testnet.mdgl.io',
    '8047': 'https://rpc0.come.boat/',
    '8054': 'https://rpc.sepolia.karak.network',
    '8080': 'https://liberty10.shardeum.org/',
    '8081': 'https://liberty20.shardeum.org/',
    '8082': 'https://sphinx.shardeum.org/',
    '8086': 'https://rpc.bitcoinevm.org',
    '8087': 'https://rpc.e-dollar.org',
    '8098': 'https://u0ma6t6heb:KDNwOsRDGcyM2Oeui1p431Bteb4rvcWkuPgQNHwB4FM@u0xy4x6x82-u0e2mg517m-rpc.us0-aws.kaleido.io/',
    '8131': 'https://testnet-qng.rpc.qitmeer.io',
    '8181': 'https://pre-boc1.beonechain.com',
    '8192': 'https://rpc.toruschain.com',
    '8194': 'https://rpc.testnet.toruschain.com',
    '8217': 'https://public-en.node.kaia.io',
    '8227': 'https://subnets.avax.network/space/mainnet/rpc',
    '8272': 'https://rpc.blocktonscan.com/',
    '8285': 'https://www.krotho-test.net',
    '8329': 'https://rpc.lorenzo-protocol.xyz',
    '8333': 'https://mainnet-rpc.b3.fun',
    '8387': 'https://api.dracones.net/',
    '8408': 'https://zenchain-testnet.api.onfinality.io/public',
    '8428': 'https://api.thatchain.io',
    '8453': 'https://mainnet.base.org/',
    '8545': 'https://rpcv1-dn-1.chakrachain.io/',
    '8654': 'https://mainnet.buildwithtoki.com/v0/rpc',
    '8655': 'https://testnet.buildwithtoki.com/v0/rpc',
    '8668': 'https://mainnet-rpc.helachain.com',
    '8723': 'https://mainnet-web3.wolot.io',
    '8724': 'https://testnet-web3.wolot.io',
    '8726': 'https://mainnet-validator.storagechain.io',
    '8727': 'https://testnet-validator.storagechain.io',
    '8732': 'https://rpc.bullionsx.org',
    '8738': 'https://rpc.alph.network',
    '8768': 'https://node1.tmyblockchain.org/rpc',
    '8822': 'https://json-rpc.evm.iotaledger.net',
    '8844': 'https://rpc-testnet.hydrachain.org',
    '8848': 'https://rpc-mainnet.ma.ro',
    '8866': 'https://mainnet.lumio.io/',
    '8869': 'https://rpc.lif3.com',
    '8880': 'https://rpc.unique.network',
    '8881': 'https://rpc-quartz.unique.network',
    '8882': 'https://rpc-opal.unique.network',
    '8883': 'https://rpc-sapphire.unique.network',
    '8886': 'https://eu-testnet.avenium.io/',
    '8888': 'https://mainnet.xana.net/rpc',
    '8889': 'https://vsc-dataseed.vyvo.org:8889',
    '8890': 'https://rpc-dev-testnet.orenium.org/',
    '8898': 'https://dataseed.mmtscan.io',
    '8899': 'https://rpc-l1.jibchain.net',
    '8911': 'https://rpc.algen.network',
    '8912': 'https://rpc.test.algen.network',
    '8921': 'https://rpc.alg2.algen.network',
    '8922': 'https://rpc.alg2-test.algen.network',
    '8989': 'https://rpc-asia.gmmtchain.io',
    '8995': 'https://core.bloxberg.org',
    '9000': 'https://evmos-testnet.lava.build',
    '9001': 'https://evmos.lava.build',
    '9003': 'https://alphatestnet-evm-rpc.qubetics.work/',
    '9007': 'https://rpc-testnet-nodes.shidoscan.com',
    '9008': 'https://rpc-nodes.shidoscan.com',
    '9012': 'https://mainnet.berylbit.io',
    '9024': 'https://rpc-testnet-nodes.nexablockscan.io',
    '9025': 'https://rpc-nodes.nexablockscan.io',
    '9069': 'https://rpc.nexus.mainnet.apexfusion.org/',
    '9070': 'https://rpc.nexus.testnet.apexfusion.org/',
    '9090': 'https://testnet.inco.org',
    '9091': 'https://tkpa-rpc1.kpachain.com/',
    '9100': 'https://genesis-gn.com',
    '9223': 'https://chain-rpc.codefin.pro',
    '9302': 'https://evm-rpc-http-reticulum.galactica.com/',
    '9339': 'https://testnet-rpc.dogcoin.me',
    '9372': 'https://rpc.testnet.oasys.games',
    '9393': 'https://sepolia-dela.deperp.com',
    '9395': 'https://mainnet-rpc.evokescan.org',
    '9496': 'https://testnet.wvm.dev',
    '9527': 'https://robin.rangersprotocol.com/api/jsonrpc',
    '9528': 'https://qeasyweb3.com',
    '9559': 'https://testnet.neonlink.io',
    '9700': 'https://dev-rpc.oortech.com',
    '9728': 'https://testnet.bnb.boba.network',
    '9768': 'https://testnet-rpc.mainnetz.io',
    '9779': 'https://rpc-mainnet.pepenetwork.io',
    '9788': 'https://rpc.testnetv2.tabichain.com',
    '9789': 'https://rpc.testnet.tabichain.com',
    '9790': 'https://evm-api.carbon.network/',
    '9792': 'https://test-evm-api.carbon.network/',
    '9797': 'https://rpc.optimusz7.com',
    '9818': 'https://data-aws-testnet.imperiumchain.com',
    '9819': 'https://data-aws-mainnet.imperiumchain.com',
    '9876': 'https://rpctestnet.binarychain.org',
    '9888': 'https://dl-rpc.dogelayer.org',
    '9897': 'https://rpc.arena-z.t.raas.gelato.cloud',
    '9898': 'https://rpc.larissa.network',
    '9901': 'https://rpc.zypher.network/',
    '9911': 'https://rpc.escscan.com/',
    '9966': 'https://dev-testnet.uxer.network',
    '9977': 'https://testnet-msc.mindchain.info/',
    '9980': 'https://rpc.combonetwork.io',
    '9981': 'https://main-rpc.volleychain.com',
    '9982': 'https://rpc.mfevscan.com',
    '9990': 'https://wss-async.agung.peaq.network',
    '9996': 'https://rpc-msc.mindchain.info/',
    '9997': 'https://testnet-rollup-api.altlayer.io',
    '9998': 'https://zitcoin.us',
    '9999': 'https://geth.dev.bccloud.net',
    '10000': 'https://smartbch.greyh.at',
    '10001': 'https://rpc-testnet.smartbch.org',
    '10010': 'https://evm.chiado.wardenprotocol.org',
    '10024': 'https://node1.testnet.gaiaopen.network',
    '10025': 'https://node.aeon.xyz/rpc',
    '10066': 'http://40.78.123.6:8545',
    '10081': 'https://rpc-1.testnet.japanopenchain.org:8545',
    '10086': 'http://geth.free.idcfengye.com',
    '10096': 'https://web3.metanovaverse.com',
    '10101': 'https://eu.mainnet.xixoio.com',
    '10143': 'https://testnet-rpc.monad.xyz',
    '10200': 'https://rpc.chiadochain.net',
    '10201': 'https://rpc.maxxchain.org',
    '10222': 'https://glc-dataseed.glscan.io/',
    '10242': 'https://rpc.arthera.net',
    '10243': 'https://rpc-test.arthera.net',
    '10248': 'https://node.0xtchain.com',
    '10321': 'https://rpc.taoevm.io',
    '10324': 'https://testnet-rpc.taoevm.io',
    '10395': 'https://gwangju.worldland.foundation',
    '10507': 'https://mainnetrpc.num.network',
    '10508': 'https://testnetrpc.num.network',
    '10823': 'http://node106.cryptocoinpay.info:8545',
    '10849': 'https://subnets.avax.network/lamina1/mainnet/rpc',
    '10850': 'https://subnets.avax.network/lamina1id/mainnet/rpc',
    '10888': 'https://rpc-testnet.gameswift.io',
    '10946': 'https://rpc.quadrans.io',
    '10947': 'https://rpctest.quadrans.io',
    '11000': 'https://mainnet-rpc.kbcfoundation.com',
    '11011': 'https://sepolia.shape.network',
    '11100': 'https://beta-rpc-node-http.bool.network',
    '11110': 'https://rpc.astranaut.io',
    '11111': 'https://subnets.avax.network/wagmi/wagmi-chain-testnet/rpc',
    '11115': 'https://rpc.astranaut.dev',
    '11119': 'https://mainnet-rpc.hashbit.org',
    '11124': 'https://api.testnet.abs.xyz',
    '11221': 'https://rpc.shinescan.io',
    '11227': 'https://subnets.avax.network/jiritsutes/testnet/rpc',
    '11235': 'https://rpc.eth.haqq.network',
    '11451': 'https://rpc.egoldchain.com',
    '11501': 'https://rpc-mainnet-1.bevm.io/',
    '11503': 'https://testnet.bevm.io/',
    '11521': 'https://rpc-satschain-1.bevm.io',
    '11612': 'https://testnet-rpc.sardisnetwork.com',
    '11820': 'https://node-euro.artela.network/rpc',
    '11822': 'https://betanet-rpc1.artela.network',
    '11888': 'https://sanrchain-node.santiment.net',
    '11891': 'https://rpc.polygonsupernet.public.arianee.net',
    '12001': 'https://rpc.flash.fuse.io',
    '12009': 'https://mainnet-rpc.satoshichain.io',
    '12020': 'https://rpc.aternoschain.com',
    '12051': 'https://betaenv.singularity.gold:18545',
    '12052': 'https://zerorpc.singularity.gold',
    '12123': 'https://rpc.brcchain.io',
    '12306': 'https://node1.fibo-api.asia',
    '12321': 'https://rpc.blgchain.com',
    '12323': 'https://huddle01.calderachain.xyz/http',
    '12324': 'https://rpc-mainnet.l3x.com',
    '12325': 'https://rpc-testnet.l3x.com',
    '12345': 'https://rpc.testnet.step.network',
    '12358': 'https://rpc.gdprchain.com',
    '12553': 'https://rpc.rss3.io',
    '12715': 'https://testnet-rpc.rikscan.com',
    '12781': 'https://subnets.avax.network/playdappte/testnet/rpc',
    '12890': 'https://testnet-rpc.quantumscan.org',
    '12898':
        'https://rpc.letsplayfair.ai/ext/bc/2hhXFNp1jR4RuqvCmWQnBtt9CZnCmmyGr7TNTkxt7XY7pAzHMY/rpc',
    '13000': 'https://rpc.ssquad.games',
    '13308': 'https://rpc.creditsmartchain.com',
    '13337': 'https://build.onbeam.com/rpc/testnet',
    '13370': 'http://127.0.0.1:8545',
    '13371': 'https://rpc.immutable.com',
    '13381': 'https://rpc.phoenixplorer.com/',
    '13396': 'https://subnets.avax.network/masanetwork/mainnet/rpc',
    '13473': 'https://rpc.testnet.immutable.com',
    '13505': 'https://rpc-sepolia.gravity.xyz',
    '13600': 'https://mainnet-rpc.qbitscan.com',
    '13746': 'https://testnet-rpc.game7.io',
    '13812':
        'https://gateway.opn.network/node/ext/bc/2VsZe5DstWw2bfgdx3YbjKcMsJnNDjni95sZorBEdk9L9Qr9Fr/rpc',
    '14000': 'https://www.3sps.net',
    '14088': 'https://test-my.zeroth.run',
    '14149': 'https://rpc.bthscan.io/',
    '14235': 'https://bitlazer.calderachain.xyz/http',
    '14324': 'https://testnet-rpc.evolveblockchain.io',
    '14333': 'https://test-rpc.vitruveo.xyz',
    '14800': 'https://rpc.moksha.vana.org',
    '14801': 'http://rpc.satori.vana.org',
    '14853': 'https://explorer-rpc-http.testnet5.stages.humanode.io',
    '15003': 'https://rpc.dev.immutable.com',
    '15257': 'https://testnet-rpc.poodl.org',
    '15259': 'https://rpc.poodl.org',
    '15430': 'https://mainnet-rpc.kymaticscan.online',
    '15551': 'https://api.mainnetloop.com',
    '15555': 'https://api.testnet-dev.trust.one',
    '15557': 'https://api.testnet.evm.eosnetwork.com',
    '16000': 'https://mainnet.metadot.network',
    '16001': 'https://testnet.metadot.network',
    '16116': 'https://rpc.defi-verse.org/',
    '16166': 'https://pubnodes.cypherium.io/rpc',
    '16180': 'https://subnets.avax.network/plyr/mainnet/rpc',
    '16182': 'https://testnet-rpc.eh-dev.app',
    '16350': 'https://rpc.ankr.com/incentiv_devnet',
    '16481': 'https://sepolia.pivotalprotocol.com',
    '16507': 'https://rpc.genesys.network',
    '16600': 'https://evmrpc-testnet.0g.ai',
    '16688': 'https://evmrpc.nyancat.irisnet.org',
    '16718': 'https://network.ambrosus.io',
    '16888': 'https://testnet-rpc.ivarex.com',
    '17000': 'https://rpc.holesky.ethpandaops.io',
    '17001': 'https://rpc.holesky.redstone.xyz',
    '17069': 'https://rpc.garnetchain.com',
    '17071': 'https://rpc.onchainpoints.xyz',
    '17117': 'https://rpc-testnet.defi-verse.org/',
    '17171': 'https://mainnet-rpc.oneg8.network',
    '17172': 'https://subnets.avax.network/eclipse/testnet/rpc',
    '17180': 'https://palette-opennet.com:22000',
    '17217': 'https://api.kon-wallet.com',
    '17777': 'https://api.evm.eosnetwork.com',
    '18000': 'https://rpc.fod.games/',
    '18122': 'https://beefledgerwallet.com:8544',
    '18159': 'https://mainnet-rpc.memescan.io',
    '18181': 'https://testnet-rpc.oneg8.network',
    '18231': 'https://rpc.unreal.gelato.digital',
    '18233': 'https://rpc.unreal-orbit.gelato.digital',
    '18686': 'https://rpc.mxc.com',
    '18880': 'https://rpc1-testnet.expchain.ai',
    '18881': 'https://evm.test.ultra.eosusa.io',
    '18888': 'https://titan-json-rpc.titanlab.io',
    '18889': 'https://titan-testnet-json-rpc.titanlab.io',
    '19011': 'https://rpc.mainnet.oasys.homeverse.games/',
    '19077': 'https://atlantis-web3.blockxnet.com',
    '19180': 'https://tgrpntwm.locachain.io',
    '19191': 'https://web3.blockxnet.com',
    '19224': 'https://rpc.decentraconnect.io',
    '19515': 'https://testnet-rpc.secexplorer.io',
    '19516': 'https://rpc.secexplorer.io',
    '19527': 'https://magnet-rpc.magport.io/',
    '19546': 'https://linea-testnet-zytron.zypher.game/',
    '19600': 'https://lbry.nl/rpc',
    '19777': 'https://rpc-astra-9on2f72wzn.t.conduit.xyz',
    '19845': 'https://seed.btcix.org/rpc',
    '19991': 'https://evm.ultra.eosusa.io',
    '20001': 'https://mainnet-http-rpc.camelark.com',
    '20041': 'https://nizascan.io/rpc',
    '20073': 'https://testnet.nizascan.io/rpc',
    '20729': 'https://testnet-rpc.callisto.network/',
    '20736': 'https://rpc-chain.p12.games',
    '20765': 'https://subnets.avax.network/jono11/testnet/rpc',
    '20993': 'https://rpc.dev.gblend.xyz',
    '21004': 'https://rpc.c4ei.net',
    '21097': 'https://validator.rivest.inco.org',
    '21133': 'https://rpc.c4ex.net',
    '21210': 'https://mainnet.1money.network',
    '21223': 'https://rpc.dcpay.io',
    '21224': 'https://testnet-rpc.dcpay.io',
    '21337': 'https://cennznet.unfrastructure.io/public',
    '21363': 'https://service.lestnet.org',
    '21816': 'https://seed.omchain.io',
    '21912': 'http://rpc-mainnet.nftruth.io:8545',
    '22023': 'https://taycan-rpc.hupayx.io:8545',
    '22040': 'https://network.ambrosus-test.io',
    '22222': 'https://api.nautilus.nautchain.xyz',
    '22324': 'https://testnet-rpc.goldxchain.io',
    '22776': 'https://rpc.maplabs.io',
    '23006': 'https://testnet-rpc.antofy.io',
    '23023': 'https://rpc.premiumblock.org',
    '23118': 'https://testrpc.opside.network',
    '23294': 'https://sapphire.oasis.io',
    '23295': 'https://testnet.sapphire.oasis.io',
    '23451': 'https://rpc.dreyerx.com',
    '23452': 'https://testnet-rpc.dreyerx.com',
    '23888': 'http://testnet-rpc.blastblockchain.com',
    '24076': 'https://testnet-rpc.kymaticscan.online',
    '24116': 'https://testnet.steamexchange.io',
    '24734': 'https://node1.mintme.com',
    '25186': 'https://mainnet.liquidlayer.network',
    '25327': 'https://rpc.everclear.raas.gelato.cloud',
    '25839': 'https://testnet-rpc.alvey.io',
    '25888': 'https://www.hammerchain.io/rpc',
    '25925': 'https://rpc-testnet.bitkubchain.io',
    '26026': 'http://testnet.dev.svcs.ferrumnetwork.io:9933',
    '26100': 'https://qpn.svcs.ferrumnetwork.io',
    '26482': 'https://ducx-testnet-node1.rocknblock.io',
    '26483': 'https://ducx-mainnet-node1.rocknblock.io',
    '26600': 'https://mainnet-rpc.hertzscan.com',
    '26863': 'https://rpc1.oasischain.io',
    '26988': 'https://jp-rpc-testnet-newfi.newpay.io',
    '27181': 'https://rpc.klaosnova.laosfoundation.io',
    '27483': 'https://sepolia-rpc.nanon.network',
    '27827': 'https://subnets.avax.network/zeroonemai/mainnet/rpc',
    '28516': 'https://rpc-sepolia.vizing.com',
    '28518': 'https://rpc.vizing.com',
    '28528': 'https://alpha-1-replica-0.bedrock-goerli.optimism.io',
    '28882': 'https://sepolia.boba.network',
    '29112': 'https://testnet-rpc.hychain.com/http',
    '29223': 'https://nexa.sh/metanet',
    '29225': 'https://nexa.sh/metatest',
    '29536': 'https://testnet-rpc.kaichain.net',
    '29548': 'https://rpc.oasys.mycryptoheroes.net',
    '30000': 'https://rpc.qchain.kr',
    '30067': 'https://testnet-rpc0.piecenetwork.com',
    '30088': 'https://blockchain.miyou.io',
    '30103': 'https://cerium-rpc.canxium.net',
    '30732': 'https://mevm.testnet.imola.movementlabs.xyz',
    '31102': 'https://api.esn.gonspool.com',
    '31223': 'https://mainnet-rpc.cloudtx.finance',
    '31224': 'https://testnet-rpc.cloudtx.finance',
    '31337': 'https://testnet-rpc.gochain.io',
    '31414': 'https://testnet-rpc.evokescan.org',
    '31415': 'https://rpc.wirexpaychain.com',
    '31611': 'https://rpc.test.mezo.org',
    '31753': 'https://rpc.xchainscan.com',
    '31754': 'https://rpc.xchaintest.net',
    '32001': 'https://rpc-holesky.w3gamez.network',
    '32382': 'https://node.sanr.app',
    '32520': 'https://rpc-bitgert.icecreamswap.com',
    '32659': 'https://mainnet.fusionnetwork.io',
    '32769': 'https://api.zilliqa.com',
    '32770': 'https://api.zq2-protomainnet.zilliqa.com',
    '32990': 'https://zilliqa-isolated-server.zilliqa.com/',
    '33033': 'https://json-rpc.entangle.fi',
    '33101': 'https://dev-api.zilliqa.com',
    '33103': 'https://api.zq2-prototestnet.zilliqa.com',
    '33111': 'https://rpc.curtis.apechain.com',
    '33133': 'https://evm-testnet.entangle.fi',
    '33139': 'https://rpc.apechain.com',
    '33210': 'https://subnets.avax.network/cloudverse/mainnet/rpc',
    '33333': 'https://rpc.avescoin.io',
    '33385': 'https://api.devnet.zilliqa.com/',
    '33401': 'https://rpc.slingshotdao.com',
    '33469': 'https://api.zq2-devnet.zilliqa.com',
    '33979': 'https://rpc-mainnet.funkichain.com',
    '34443': 'https://mainnet.mode.network',
    '34504': 'https://mainnet-rpc.zeuschainscan.io',
    '35011': 'https://rpc.j2o.io',
    '35441': 'https://rpc.q.org',
    '35443': 'https://rpc.qtestnet.org',
    '37111': 'https://rpc.testnet.lens.dev',
    '38400': 'https://cm.rangersprotocol.com/api/jsonrpc',
    '38401': 'https://robin-cm.rangersprotocol.com/api/jsonrpc',
    '39656': 'https://mainnet-rpc.prmscan.org',
    '39797': 'https://nodeapi.energi.network',
    '39815': 'https://mainnet.oho.ai',
    '40000': 'https://rpc.divchain.org',
    '41455': 'https://rpc.alephzero.raas.gelato.cloud',
    '41500': 'https://connect.opulent-x.com',
    '41923': 'https://rpc.edu-chain.raas.gelato.cloud',
    '42001': 'https://rpc.pmon.xyz',
    '42026': 'https://rpc.donatuz.com',
    '42070': 'https://rpc-testnet-base.worldmobile.net',
    '42072': 'https://testnet-rpc.agentlayer.xyz',
    '42161': 'https://arbitrum-mainnet.infura.io/v3/${INFURA_API_KEY}',
    '42170': 'https://nova.arbitrum.io/rpc',
    '42220': 'https://forno.celo.org',
    '42261': 'https://testnet.emerald.oasis.io/',
    '42262': 'https://emerald.oasis.io',
    '42355': 'https://mainnet-rpc.goldxchain.io',
    '42420': 'https://mainnet-rpc.assetchain.org',
    '42421': 'https://enugu-rpc.assetchain.org',
    '42766': 'https://rpc.zkfair.io',
    '42793': 'https://node.mainnet.etherlink.com',
    '42801': 'https://rpc.testnet.verse.gesoten.com/',
    '42888': 'http://35.215.120.180:8545',
    '43110': 'https://ava.network:21015/ext/evm/rpc',
    '43113': 'https://api.avax-test.network/ext/bc/C/rpc',
    '43114': 'https://api.avax.network/ext/bc/C/rpc',
    '43288': 'https://avax.boba.network',
    '43521': 'https://rpc.formicarium.memecore.net',
    '43851': 'https://testnet-rpc.zkfair.io',
    '44444': 'https://rpc-02.frenscan.io',
    '44445': 'https://rpcqtm.avescoin.io',
    '44787': 'https://alfajores-forno.celo-testnet.org',
    '45000': 'https://rpc.autobahn.network',
    '45454': 'https://swamps.tc.l2aas.com',
    '45510': 'https://rpc.deelance.com',
    '45513': 'https://blessnet.calderachain.xyz/http',
    '46688': 'https://testnet.fusionnetwork.io',
    '47763': 'https://mainnet-1.rpc.banelabs.org',
    '47803': 'https://layer1.redefi.world',
    '47805': 'https://rpc.rei.network',
    '48795': 'https://subnets.avax.network/space/testnet/rpc',
    '48899': 'https://zircuit1-testnet.p2pify.com/',
    '48900': 'https://zircuit1-mainnet.p2pify.com/',
    '49049': 'https://rpc-floripa.wireshape.org',
    '49088': 'https://public-01.testnet.bifrostnetwork.com/rpc',
    '49321': 'https://rpc.gunz.dev/ext/bc/ryk9vkvNuKtewME2PeCgybo9sdWXGmCkBrrx4VPuZPdVdAak8/rpc',
    '49797': 'https://nodeapi.test.energi.network',
    '50000': 'https://rpc.citronus.com',
    '50001': 'https://rpc.oracle.liveplex.io',
    '50005': 'https://rpc.yooldo-verse.xyz/',
    '50006': 'https://rpc.testnet.yooldo-verse.xyz/',
    '50021': 'https://testnet.gton.network/',
    '50104': 'https://rpc.sophon.xyz',
    '50311': 'https://dream-rpc.somnia.network',
    '50341': 'https://reddio-dev.reddio.com',
    '50505': 'https://rpc.quorum.sps.dev.kode.ru/',
    '50888': 'https://api.erbie.io',
    '51178': 'https://alpha-us-http-geth.lumoz.org',
    '51712': 'https://mainnet-rpc.sardisnetwork.com',
    '52014': 'https://rpc.electroneum.com',
    '52225': 'http://rpc.sl.testnet.cytonic.com',
    '53277': 'https://rpc.doid.tech',
    '53302': 'https://sepolia.superseed.xyz',
    '53457': 'https://dodochain-testnet.alt.technology',
    '53935': 'https://subnets.avax.network/defi-kingdoms/dfk-chain/rpc',
    '54170': 'https://anon-entrypoint-test-1.atgraphite.com',
    '54176': 'https://rpc.overprotocol.com',
    '54211': 'https://rpc.eth.testedge2.haqq.network',
    '54321': 'https://testnet.toronet.org/rpc',
    '55004': 'https://rpc.titan.tokamak.network',
    '55007': 'https://rpc.titan-sepolia.tokamak.network',
    '55244': 'https://rpc.superposition.so',
    '55551': 'https://rpc-test2.photonchain.io',
    '55555': 'https://rei-rpc.moonrhythm.io',
    '55556': 'https://rei-testnet-rpc.moonrhythm.io',
    '55614': 'https://rpc.flamma.network',
    '56026': 'https://nrpc.lambda.im/',
    '56288': 'https://bnb.boba.network',
    '56400': 'https://subnets.avax.network/testnetzer/testnet/rpc',
    '56789': 'https://nova.velo.org',
    '56797': 'https://rpc.testnet.doid.tech',
    '57000': 'https://rpc-tanenbaum.rollux.com',
    '57054': 'https://rpc.blaze.soniclabs.com',
    '57073': 'https://rpc-gel.inkonchain.com',
    '57451': 'https://mainnet-rpc.coinsec.network',
    '58008': 'https://sepolia.publicgoods.network',
    '58680': 'https://quidditch-rpc.lumoz.org',
    '59140': 'https://rpc.goerli.linea.build',
    '59141': 'https://rpc.sepolia.linea.build',
    '59144': 'https://rpc.linea.build',
    '59902': 'https://sepolia.metisdevops.link',
    '59971': 'https://mainnet.genesyscode.io/',
    '60000': 'https://test.thinkiumrpc.net/',
    '60001': 'https://test1.thinkiumrpc.net/',
    '60002': 'https://test2.thinkiumrpc.net/',
    '60103': 'https://test103.thinkiumrpc.net/',
    '60808': 'https://rpc.gobob.xyz',
    '61022': 'https://rpc.orangechain.xyz',
    '61166': 'https://rpc.treasure.lol',
    '61406': 'https://mainnet-rpc.kaichain.net',
    '61800': 'https://aium-rpc-dev.viacube.com',
    '61803': 'https://eticamainnet.eticascan.org',
    '61916': 'https://sgrpc.doken.dev',
    '62049': 'https://rpc-testnet.optopia.ai',
    '62050': 'https://rpc-mainnet.optopia.ai',
    '62092': 'https://tiktrix-rpc.xyz',
    '62298': 'https://rpc.devnet.citrea.xyz',
    '62320': 'https://baklava-forno.celo-testnet.org',
    '62621': 'https://rpc.mtv.ac',
    '62831': 'https://subnets.avax.network/plyr/testnet/rpc',
    '62850': 'https://rpc.laossigma.laosfoundation.io',
    '63000': 'https://rpc.esync.network',
    '63002': 'https://rpc.tst.esync.network',
    '63157': 'https://geist-mainnet.g.alchemy.com/public',
    '65349': 'https://cratd2c-testnet-node1.cratd2csmartchain.io/',
    '65357': 'https://rpc.vecno.org',
    '65450': 'https://mainnet-rpc.scolcoin.com',
    '65535': 'https://rpc.cyberchain.xyz/',
    '65536': 'https://rpc.ata.network',
    '66665': 'https://rpc.creatorchain.io',
    '66988': 'https://rpc.test.janusnetwork.io',
    '67390':
        'https://u0tnafcv6j:o2T045sxuCNXL878RDQLp5__Zj-es2cvdjtgkl4etn0@u0v7kwtvtg-u0wj114sve-rpc.us0-aws.kaleido.io/',
    '67588': 'http://testnet.cosmicchain.site:3344',
    '68770': 'https://rpc.dm2verse.dmm.com',
    '68775': 'https://rpc.testnet.dm2verse.dmm.com',
    '69420': 'https://rpc.condrieu.ethdevops.io:8545',
    '70000': 'https://proxy.thinkiumrpc.net/',
    '70001': 'https://proxy1.thinkiumrpc.net/',
    '70002': 'https://proxy2.thinkiumrpc.net/',
    '70103': 'https://proxy103.thinkiumrpc.net/',
    '70700': 'https://rpc.apex.proofofplay.com',
    '70701': 'https://rpc.boss.proofofplay.com',
    '71111': 'https://rpc-mainnet.guapcoinx.com/',
    '71117': 'https://rpc-testnet.wadzchain.io',
    '71393': 'https://godwoken-testnet-web3-rpc.ckbapp.dev',
    '71401': 'https://godwoken-testnet-v1.ckbapp.dev',
    '71402': 'https://v1.mainnet.godwoken.io/rpc',
    '72080': 'https://rpc.testnet.nexera.network',
    '72778': 'https://www.ankara-cagacrypto.com',
    '72888': 'https://cagamainnet.com',
    '72992': 'https://mainnet-rpc.grokchain.dev',
    '73114': 'https://rpc1-testnet.icbnetwork.info/',
    '73115': 'https://rpc1-mainnet.icbnetwork.info/',
    '73799': 'https://volta-rpc.energyweb.org',
    '73927': 'https://geth.mvm.dev',
    '75338': 'https://testnet-api.applayer.com',
    '75512': 'https://rpc.geekout-pte.com',
    '75513': 'https://rpc-testnet.geekout-pte.com',
    '77001': 'https://public-node.api.boraportal.com/bora/mainnet',
    '77238': 'https://testnet-rpc.foundryscan.org/',
    '77612': 'https://mainnet-rpc.vention.network',
    '77652': 'https://rpc-testnetcarrchain.artiffine.com',
    '77677': 'https://sailboat-rpc-mainnet.cyclenetwork.io',
    '77777': 'https://www.toronet.org/rpc2/',
    '78110': 'https://ethnode.primusmoney.com/firenze',
    '78281': 'https://dragonfly-rpc.switch.ch',
    '78430': 'https://subnets.avax.network/amplify/testnet/rpc',
    '78431': 'https://subnets.avax.network/bulletin/testnet/rpc',
    '78432': 'https://subnets.avax.network/conduit/testnet/rpc',
    '78600': 'https://rpc-vanguard.vanarchain.com',
    '79879': 'https://rpc-testnet.goldsmartchain.com',
    '80001': 'https://rpc-mumbai.maticvigil.com',
    '80002': 'https://rpc-amoy.polygon.technology',
    '80008': 'https://rpc.sepolia.polynomial.fi',
    '80084': 'https://bartio.rpc.berachain.com',
    '80085': 'https://artio.rpc.berachain.com',
    '80094': 'https://rpc.berachain.com',
    '80096': 'https://hizoco.net/rpc',
    '80451': 'https://rpc-geo-genesis-h0q2s21xx8.t.conduit.xyz/',
    '80931': 'https://rpc-forta-chain-8gj1qndmfc.t.conduit.xyz',
    '81041': 'https://mainnet-rpc.nordekscan.com',
    '81457': 'https://rpc.blast.io',
    '81720': 'https://rpc.quantumscan.org',
    '82459': 'https://rpc.test.smartlayer.network',
    '82614': 'https://vemp-horizon.calderachain.xyz/http',
    '83144': 'https://rpc.testnet.xprotocol.org',
    '83278': 'http://65.108.151.70:8545',
    '83872': 'https://mainnet-rpc.zedscan.net',
    '84531': 'https://goerli.base.org',
    '84532': 'https://sepolia.base.org',
    '84841': 'https://rpc.o.xyz',
    '84886': 'https://mainnet.aerielab.io',
    '85321': 'https://rpc.testnet.gdprchain.com',
    '85449': 'http://testnet.cybertrust.space:48501',
    '88002': 'https://api.proteus.nautchain.xyz/solana',
    '88559': 'https://inoai-network.com',
    '88800': 'https://rpc.zkas.zeeve.net',
    '88811': 'https://rpc.unit0.dev',
    '88817': 'https://rpc-testnet.unit0.dev',
    '88819': 'https://rpc-stagenet.unit0.dev',
    '88866': 'https://testnet-rpc.m1chain.io',
    '88880': 'https://scoville-rpc.chiliz.com',
    '88882': 'https://spicy-rpc.chiliz.com',
    '88888': 'https://rpc.chiliz.com',
    '88899': 'https://unite-mainnet.g.alchemy.com/public',
    '90001': 'https://testnet-fx-json-web3.functionx.io:8545',
    '90002': 'https://rpc.ubitscan.io',
    '90210': 'https://rpc.beverlyhills.ethdevops.io:8545',
    '90354': 'https://rpc-camp-network-4xje7wy105.t.conduit.xyz',
    '91002': 'https://triton.api.nautchain.xyz',
    '91111': 'https://henez.calderachain.xyz/http',
    '91120': 'https://rpc.chain.metadap.io',
    '91715': 'https://test-rpc.combonetwork.io',
    '92001': 'https://evm.lambda.top/',
    '93572': 'https://testnet.liquidlayer.network',
    '93747': 'https://rpc.stratovm.io',
    '95432': 'https://rpc.sriscan.com/',
    '96368': 'https://api.lux-test.network',
    '96369': 'https://api.lux.network',
    '96970': 'https://mantis-rpc.switch.ch',
    '97053': 'https://test-rpc.tscscan.org',
    '97055': 'https://rpc.tscscan.org',
    '97435': 'https://rpc-dependent-emerald-whippet-gh6kch3nen.t.conduit.xyz',
    '97453': 'https://node.sidrachain.com',
    '97531': 'https://node.greenchain.app/rpc/',
    '97766': 'https://rpc.metabenzscan.com',
    '97970': 'https://testnet-rpc.optimusz7.com',
    '98864': 'https://test-rpc.plumenetwork.xyz',
    '98865': 'https://rpc.plumenetwork.xyz',
    '98881': 'https://rpc.ebi.xyz',
    '98985': 'https://testnet-rpc.superposition.so',
    '99099': 'https://testnet-rpc.eliberty.ngo',
    '99876': 'https://rpc1-testnet.emc.network',
    '99879': 'https://rpc1-sepolia.emc.network',
    '99998': 'https://testnet.rpc.uschain.network',
    '99999': 'https://rpc.uschain.network',
    '100000': 'http://jrpc.mainnet.quarkchain.io:38391',
    '100001': 'https://mainnet-s0-ethapi.quarkchain.io',
    '100002': 'https://mainnet-s1-ethapi.quarkchain.io',
    '100003': 'https://mainnet-s2-ethapi.quarkchain.io',
    '100004': 'https://mainnet-s3-ethapi.quarkchain.io',
    '100005': 'https://mainnet-s4-ethapi.quarkchain.io',
    '100006': 'https://mainnet-s5-ethapi.quarkchain.io',
    '100007': 'https://mainnet-s6-ethapi.quarkchain.io',
    '100008': 'https://mainnet-s7-ethapi.quarkchain.io',
    '100009': 'https://rpc-mainnet.vechain.energy',
    '100010': 'https://rpc-testnet.vechain.energy',
    '100011': 'https://mainnet-l2-ethapi.quarkchain.io',
    '101010': 'https://gtn.stabilityprotocol.com',
    '102030': 'https://mainnet3.creditcoin.network',
    '102031': 'https://rpc.cc3-testnet.creditcoin.network',
    '102032': 'https://rpc.cc3-devnet.creditcoin.network',
    '103090': 'https://evm.cryptocurrencydevs.org',
    '103454': 'https://subnets.avax.network/masatestne/testnet/rpc',
    '104566': 'https://api.kaspaclassic.world/',
    '105105': 'https://rpc.stratisevm.com',
    '108801': 'https://rpc.brochain.org',
    '110000': 'http://jrpc.devnet.quarkchain.io:38391',
    '110001': 'https://devnet-s0-ethapi.quarkchain.io',
    '110002': 'https://devnet-s1-ethapi.quarkchain.io',
    '110003': 'https://devnet-s2-ethapi.quarkchain.io',
    '110004': 'https://devnet-s3-ethapi.quarkchain.io',
    '110005': 'https://devnet-s4-ethapi.quarkchain.io',
    '110006': 'https://devnet-s5-ethapi.quarkchain.io',
    '110007': 'https://devnet-s6-ethapi.quarkchain.io',
    '110008': 'https://devnet-s7-ethapi.quarkchain.io',
    '110011': 'https://testnet-l2-ethapi.quarkchain.io',
    '110110': 'https://node99-production-dd5f.up.railway.app:443',
    '111000': 'https://rpc.test.siberium.net',
    '111111': 'https://rpc.main.siberium.net',
    '111188': 'https://rpc.realforreal.gelato.digital',
    '111451': 'https://rpc-testnet.egoldchain.com',
    '112358': 'https://rpc.metachain.one',
    '119139': 'https://rpc.testnet.chain.metadap.io',
    '123321': 'https://evm-rpc.gemchain.org',
    '123456': 'https://devnet.adilchain-rpc.io',
    '124832': 'https://rpc.testnet.mitosis.org',
    '128123': 'https://node.ghostnet.etherlink.com',
    '131313': 'https://testnode.dioneprotocol.com/ext/bc/D/rpc',
    '131419': 'https://rpc.node1.etnd.pro/',
    '132902': 'https://sepolia-rpc.form.network/http',
    '141319': 'https://testnet-api.magape.io/chain/',
    '141491': 'https://rpc-testnet.bthscan.io/',
    '142857': 'https://rpcmainnet.ic-plaza.org/',
    '153153': 'https://node.dioneprotocol.com/ext/bc/D/rpc',
    '158245': 'https://rpc-xcoin.cryptoxnetwork.io',
    '158345': 'https://rpc-xcoin.cryptoxnetwork.io',
    '161201': 'https://rpctn.openledger.xyz',
    '165279': 'https://mainnet-rpc.eclatscan.com',
    '167000': 'https://rpc.mainnet.taiko.xyz',
    '167004': 'https://rpc.a2.taiko.xyz',
    '167005': 'https://rpc.test.taiko.xyz',
    '167006': 'https://rpc.l3test.taiko.xyz',
    '167007': 'https://rpc.jolnir.taiko.xyz',
    '167009': 'https://rpc.hekla.taiko.xyz',
    '168168': 'https://rpc.zchains.com',
    '171000': 'https://rpc-testnet.xfair.ai',
    '171717': 'https://rpc.wadzchain.io',
    '175177': 'https://chain-rpc.litprotocol.com/http',
    '175188': 'https://yellowstone-rpc.litprotocol.com',
    '175190': 'https://loa-rpc.litprotocol.com',
    '188710': 'https://mainnet-rpc.biticablockchain.com/',
    '188881': 'https://testnet.condor.systems/rpc',
    '192940': 'https://rpc-testnet.mindnetwork.xyz',
    '193939': 'https://rpc-r0ar.io',
    '199991': 'https://testnet-rpc.mazze.io/',
    '200000': 'https://rpc_testnet.xfair.ai',
    '200101': 'https://rpc-devnet-cardano-evm.c1.milkomeda.com',
    '200200': 'https://api.zoo.network',
    '200202': 'https://rpc-devnet-algorand-rollup.a1.milkomeda.com',
    '200625': 'https://remote.akroma.io',
    '200810': 'https://testnet-rpc.bitlayer.org',
    '200901': 'https://rpc.bitlayer.org',
    '201018': 'https://openapi.alaya.network/rpc',
    '201030': 'https://devnetopenapi.alaya.network/rpc',
    '201804': 'https://chain-rpc.mythicalgames.com',
    '202020': 'https://testnet-val.decimalchain.com/web3/',
    '202105': 'https://testnet-rpc.duckchain.io',
    '202202': 'https://rpc-sydney.bethel.network',
    '202212': 'https://x1-devnet.xen.network',
    '202401': 'http://39.119.118.216:8545',
    '202424': 'https://rpc.blockfitscan.io',
    '202624': 'https://jellie-rpc.twala.io/',
    '204005': 'https://x1-testnet.xen.network',
    '205205': 'https://auroria.rpc.stratisevm.com',
    '210049': 'https://rpc.gitagi.org',
    '210209': 'https://rpc.sorian.io',
    '210210': 'https://testnet-rpc.sorian.io',
    '210425': 'https://openapi2.platon.network/rpc',
    '212013': 'https://rpc.litentry-parachain.litentry.io',
    '220315': 'http://node.masnet.ai:8545',
    '221230': 'https://eth.reapchain.org',
    '221231': 'https://test-eth.reapchain.org',
    '222222': 'https://rpc.hydradx.cloud',
    '222555': 'https://rpc.deeplnetwork.org',
    '222666': 'https://testnet.deeplnetwork.org',
    '224168': 'https://mainnet.tafchain.com/v1',
    '224400': 'https://mainnet-rpc.conet.network',
    '224422': 'https://rpc1.conet.network',
    '224433': 'https://rpc.conet.network',
    '229772': 'https://testnet.rpc.abyssprotocol.ai/',
    '230315': 'https://testnet.hashkeychain/rpc',
    '234666': 'https://testnet1.haymo.network',
    '235711': 'https://blockchain.dev-universe-bank.com',
    '240240': 'https://rpc.studio-blockchain.com',
    '240515': 'https://testnet-rpc.orangechain.xyz',
    '241120': 'https://rpc.anomaly-andromeda.anomalygames.io',
    '246529': 'https://rpc.sigma1.artis.network',
    '246785': 'https://rpc.tau1.artis.network',
    '247253': 'https://rpc-testnet.saakuru.network',
    '256256': 'https://mainnet.block.caduceus.foundation',
    '262371': 'https://testnet-rpc.eclatscan.com',
    '266256': 'https://gzn-test.linksme.info',
    '271271': 'https://rpctest.egonscan.com',
    '272247': 'https://nxy.social/testnet',
    '272520': 'https://nxy.social/mainnet',
    '281121': 'https://socialsmartchain.digitalnext.business',
    '281123': 'https://rpc.parthenon.athenescan.io',
    '282828': 'https://sepolia.zillnet.io/rpc',
    '292003': 'https://testnet.cipherem.com',
    '309075': 'https://mainnet-rpc.oneworldchain.org',
    '313313': 'https://testnet.saharalabs.ai',
    '314159': 'https://api.calibration.node.glif.io/rpc/v1',
    '322202': 'https://mainnet-rpc.parex.network',
    '323213': 'https://testnet-rpc.bloomgenesis.com',
    '325000': 'https://rpc-campnetwork.xyz',
    '327126': 'https://rpc.wabaworld.com',
    '328527': 'https://rpc.nal.network',
    '330844': 'https://mainnet-rpc.tscscan.com',
    '333313': 'https://mainnet-rpc.bloomgenesis.com',
    '333331': 'https://test.rpc.avescoin.io',
    '333333': 'https://rpctest.nativ3.network',
    '333666': 'https://rpc.testnet.oonechain.com',
    '333777': 'https://rpc.dev.oonechain.com',
    '333888': 'https://sparta-rpc.polis.tech',
    '333999': 'https://rpc.polis.tech',
    '336655': 'https://rpc-testnet.uniport.network',
    '336666': 'https://rpc.uniport.network',
    '355110': 'https://mainnet.bitfinity.network',
    '355113': 'https://testnet.bitfinity.network',
    '360890': 'https://tsub360890-eth-rpc.thetatoken.org/rpc',
    '363636': 'https://dgs-rpc.digitsoul.co.th',
    '373737': 'https://jsonrpc-test.hap.land',
    '381931': 'https://api.metalblockchain.org/ext/bc/C/rpc',
    '381932': 'https://tahoe.metalblockchain.org/ext/bc/C/rpc',
    '383353': 'https://rpc.cheesechain.xyz',
    '404040': 'https://mainnet-rpc.tipboxcoin.net',
    '413413': 'https://rpc1-testnet.aiechain.io',
    '420000': 'https://rpc.infinaeon.com',
    '420042': 'https://rpc.vscblockchain.org',
    '420420': 'https://mainnet.kekchain.com',
    '420666': 'https://testnet.kekchain.com',
    '420692': 'https://l2-testnet-rpc.altscan.org',
    '421611': 'https://rinkeby.arbitrum.io/rpc',
    '421613': 'https://goerli-rollup.arbitrum.io/rpc',
    '421614': 'https://sepolia-rollup.arbitrum.io/rpc',
    '424242': 'https://rpc.testnet.fastexchain.com',
    '431140': 'https://rpc.markr.io/ext/',
    '432201': 'https://subnets.avax.network/dexalot/testnet/rpc',
    '432204': 'https://subnets.avax.network/dexalot/mainnet/rpc',
    '440017': 'https://anon-entrypoint-1.atgraphite.com',
    '444444': 'https://sepolia.syndr.com/http',
    '444900': 'https://weelinknode1c.gw002.oneitfarm.com',
    '471100': 'https://test-rpc.patex.io/',
    '473861': 'https://mainnet-rpc.ultraproscan.io',
    '474142': 'https://baas-rpc.luniverse.io:18545?lChainId=1641349324562974539',
    '486487': 'https://rpc.gobbl.io',
    '490000': 'https://auto-evm.taurus.autonomys.xyz/ws',
    '490092': 'https://rpc1testnet.pumpfi.me',
    '504441': 'https://subnets.avax.network/playdappne/mainnet/rpc',
    '512512': 'https://galaxy.block.caduceus.foundation',
    '513100': 'https://rpc.dischain.xyz',
    '526916': 'https://rpc.docoin.shop',
    '534351': 'https://sepolia-rpc.scroll.io',
    '534352': 'https://rpc.scroll.io',
    '534353': 'https://alpha-rpc.scroll.io/l2',
    '534849': 'https://rpc.shinarium.org',
    '535037': 'https://mainnet-rpc.bescscan.io',
    '541764': 'https://rpc.dolphin.overprotocol.com',
    '543210': 'https://rpc.zerion.io/v1/zero',
    '552981': 'https://testnet-rpc.oneworldchain.org',
    '555555': 'https://rpc-testnet.pentagon.games',
    '555666': 'https://subnets.avax.network/eclipsecha/testnet/rpc',
    '555888': 'https://dustboy-rpc.jibl2.com/',
    '621847': 'https://testnet-rpc.trumpchain.io',
    '622277': 'https://rpc.hypra.network',
    '622463': 'https://rpc.testnet.atl.network',
    '631571': 'https://geist-polter.g.alchemy.com/public',
    '641230': 'https://brnkc-mainnet.bearnetwork.net',
    '651940': 'https://mainnet-rpc.alltra.global',
    '656476': 'https://rpc.open-campus-codex.gelato.digital',
    '660279': 'https://xai-chain.net/rpc',
    '666666': 'https://vpioneer.infragrid.v.network/ethereum/compatible',
    '666888': 'https://testnet-rpc.helachain.com',
    '668668': 'https://conwai.calderachain.xyz/http',
    '686868': 'https://rpc.wonnetwork.org',
    '696969': 'https://devnet.galadriel.com',
    '706883': 'https://fidesf1-rpc.fidesinnova.io',
    '710420': 'https://subnets.avax.network/tiltyard/mainnet/rpc',
    '713715': 'https://evm-rpc-arctic-1.sei-apis.com',
    '715131': 'https://rpc.zether.org',
    '721529': 'https://mainnet-rpc.eramscan.com',
    '723107': 'https://subnets.avax.network/tixchain/testnet/rpc',
    '743111': 'https://testnet.rpc.hemi.network/rpc',
    '751230': 'https://brnkc-test.bearnetwork.net',
    '752024': 'https://rpc.zkevm.ternoa.network',
    '752025': 'https://rpc-mainnet.zkevm.ternoa.network',
    '756689': 'https://rpc.payscan.live',
    '761412': 'https://mainnet-rpc.miexs.com',
    '763373': 'https://rpc-gel-sepolia.inkonchain.com',
    '764984': 'https://subnets.avax.network/lamina1tes/testnet/rpc',
    '767368': 'https://subnets.avax.network/lamina1id/testnet/rpc',
    '776877': 'https://fraa-dancebox-3035-rpc.a.dancebox.tanssi.network',
    '786786': 'https://rpc.zebrocoin.app',
    '800001': 'https://rpc.octa.space',
    '808080': 'https://rpc-testnet.bizex.io/',
    '808813': 'https://bob-sepolia.rpc.gobob.xyz',
    '810180': 'https://rpc.zklink.io',
    '810181': 'https://sepolia.rpc.zklink.io',
    '810182': 'https://goerli.rpc.zklink.io',
    '812397': 'https://rpc.sgverse.net/',
    '820522': 'https://testnet.tscscan.io/testrpc',
    '827431': 'https://mainnet-rpc.curvescan.io',
    '839320': 'https://testnet-rpc.prmscan.org',
    '839999': 'https://evm-tst3.exsat.network',
    '840000': 'https://rpc.runevm.io/',
    '846000': 'https://chain.deptofgood.com',
    '855456': 'https://fraa-dancebox-3041-rpc.a.dancebox.tanssi.network',
    '879151': 'https://mainnet-rpc.blxscan.com/',
    '888882': 'https://rpc.rexxnetwork.com',
    '888888': 'https://infragrid.v.network/ethereum/compatible',
    '888991': 'https://unite-testnet.g.alchemy.com/public',
    '900000': 'https://api.posichain.org',
    '910000': 'https://api.s0.t.posichain.org',
    '911867': 'https://odyssey.ithaca.xyz',
    '912559': 'https://rpc.evm.dusk-3.devnet.astria.org',
    '918273': 'https://rpc.owshen.io',
    '920000': 'https://api.s0.d.posichain.org',
    '920001': 'https://api.s1.d.posichain.org',
    '923018': 'https://fncy-testnet-seed.fncy.world',
    '955081': 'https://subnets.avax.network/jono12/testnet/rpc',
    '955305': 'https://host-76-74-28-226.contentfabric.io/eth/',
    '978658': 'https://rpc.topaz.treasure.lol',
    '984122': 'https://rpc.forma.art',
    '984123': 'https://rpc.sketchpad-1.forma.art',
    '988207': 'https://mainnet-rpc.ecroxscan.com/',
    '998899': 'https://testnet-rpc.supernet.chaingames.io/',
    '999999': 'https://node1.amchain.net',
    '1100789': 'https://testblock.protago-dev.com',
    '1127469': 'https://subnets.avax.network/tiltyard/testnet/rpc',
    '1212101': 'https://testnet.1money.network',
    '1234567': 'https://mainnet.sharecle.com',
    '1261120': 'https://rpc.zkatana.gelato.digital',
    '1313114': 'https://rpc.ethoprotocol.com',
    '1313500': 'https://rpc.xerom.org',
    '1337702': 'https://rpc.kintsugi.themerge.dev',
    '1337802': 'https://rpc.kiln.themerge.dev',
    '1337803': 'https://rpc.zhejiang.ethpandaops.io',
    '1398243': 'https://rpc-testnet.ata.network',
    '1398244': 'https://rpc-orbit-testnet.ata.network',
    '1501869': 'https://rpc.testnet9.waterfall.network',
    '1612127': 'https://albireo-rpc.playfi.ai',
    '1637450': 'https://xterio-testnet.alt.technology',
    '1731313': 'https://devchain-poa.huabeizhenxuan.com',
    '1998991': 'http://testnet.x-phere.com',
    '2021398': 'http://rpc.testnet.debank.com',
    '2099156': 'https://mainnet.plian.io/pchain',
    '2203181': 'https://devnetopenapi2.platon.network/rpc',
    '2206132': 'https://devnet2openapi.platon.network/rpc',
    '2222222': 'https://api-cloud.coinweb.io/eth-rpc-service/bnb',
    '2611555': 'https://sc-rpc.dpu.ac.th',
    '2702128': 'https://xterio-eth.alt.technology',
    '3132023': 'https://mainnet.saharalabs.ai',
    '3397901': 'https://funki-testnet.alt.technology',
    '3441005': 'https://manta-testnet.calderachain.xyz/http',
    '3441006': 'https://pacific-rpc.sepolia-testnet.manta.network/http',
    '4000003': 'https://zero.alt.technology',
    '4281033': 'https://worlds-test.calderachain.xyz/http',
    '4284265': 'https://rpc.zuux.network',
    '4444444': 'https://altar-rpc.ceremonies.ai/',
    '4457845': 'https://rpc.zerion.io/v1/zero-sepolia',
    '5112023': 'https://rpc-mainnet.numblock.org',
    '5167003': 'https://wannsee-rpc.mxc.com',
    '5167004': 'https://geneva-rpc.moonchain.com',
    '5201420': 'https://testnet-rpc.electroneum.com',
    '5318008': 'https://kopli-rpc.reactive.network',
    '5511555': 'https://rpc-testnet.pointpay.io',
    '5555555': 'https://jsonrpc.imversed.network',
    '5555558': 'https://jsonrpc-test.imversed.network',
    '6038361': 'https://rpc.startale.com/zkyoto',
    '6666665': 'https://rpc.anwang.com',
    '6666666': 'https://rpc-testnet.anwang.com',
    '7082400': 'https://testnet.coti.io/rpc',
    '7225878': 'https://rpc.saakuru.network',
    '7355310': 'https://mainnet-external.openvessel.io',
    '7668378': 'https://rpc.testnet.qom.one',
    '7762959': 'https://mewapi.musicoin.tw',
    '7777777': 'https://rpc.zora.energy/',
    '7849306': 'https://ozean-testnet.rpc.caldera.xyz/http',
    '8007736': 'https://mainnet.plian.io/child_0',
    '8008135': 'https://api.helium.fhenix.zone',
    '8080808': 'https://mainnet.hokum.gg',
    '8601152': 'https://rpc.testnet8.waterfall.network/',
    '8794598': 'https://jsonrpc.hap.land',
    '9322252': 'https://xcap-mainnet.relay.xcap.network/znzvh2ueyvm2yts5fv5gnul395jbkfb2/rpc1',
    '9322253': 'https://xcap-milvine.relay.xcap.network/zj5l55ftsgi027kz4nf14vs8d89inego/rpc1',
    '9999999': 'https://rpc.mainnet.fluence.dev/',
    '10067275': 'https://testnet.plian.io/child_test',
    '10101010': 'https://mainnet-rpc.soverun.com',
    '10241024': 'https://rpc.alienxchain.io/http',
    '10241025': 'https://hal-rpc.alienxchain.io/http',
    '11145513': 'https://blessnet-sepolia-testnet.rpc.caldera.xyz/http',
    '11155111': 'https://rpc.sepolia.org',
    '11155420': 'https://sepolia.optimism.io',
    '11166111': 'https://testnet.rpc-r0ar.io',
    '12020498': 'https://rpc.lummio.net',
    '12052024': 'https://test-rpc.mementoblockchain.com/IRkghvI3FfEArEJMr4zC/rpc',
    '12227331': 'https://neoxseed1.ngd.network/',
    '12227332': 'https://testnet.rpc.banelabs.org/',
    '13068200': 'https://devnet.coti.io/rpc',
    '13371337': 'https://churchill-rpc.pepchain.io',
    '14288640': 'https://rpc.anduschain.io/rpc',
    '16658437': 'https://testnet.plian.io/testnet',
    '17000920': 'https://testnrpc.lambda.im/',
    '18071918': 'https://mande-mainnet.public.blastapi.io',
    '18289463': 'https://net.iolite.io',
    '19850818': 'https://rpc-testnet.dbcwallet.io',
    '19880818': 'https://rpc.dbcwallet.io',
    '20180427': 'https://free.testnet.stabilityprotocol.com',
    '20180430': 'https://jsonapi1.smartmesh.cn',
    '20181205': 'https://hz.rpc.qkiscan.cn',
    '20201022': 'https://pegorpc.com',
    '20221001': 'https://sepolia.rpc.soonchain.ai',
    '20230825': 'https://testnet.vcity.app',
    '20240324': 'https://sepolia-rpc.testnet.debank.com',
    '20240603': 'https://rpc.mainnet.dbkchain.io',
    '20241133': 'https://rpc-proxima.swanchain.io',
    '20256789': 'https://rpc.etpscan.xyz',
    '20482050': 'https://testnet.hokum.gg',
    '21000000': 'https://mainnet.corn-rpc.com',
    '21000001': 'https://testnet.corn-rpc.com',
    '22052002': 'https://edgewallet1.xlon.org/',
    '24772477': 'https://rpc-testnet.6do.world',
    '27082017': 'https://testnet-rpc.exlscan.com',
    '27082022': 'https://rpc.exlscan.com',
    '28122024': 'https://rpcv2-testnet.ancient8.gg',
    '28945486': 'https://rpc.auxilium.global',
    '29032022': 'https://flachain.flaexchange.top/',
    '33626250': 'https://rpc.toliman.suave.flashbots.net',
    '33772211': 'https://rpc-testnet.xone.plus',
    '34949059': 'https://rpc.citro-testnet.t.raas.gelato.cloud',
    '35855456': 'https://node.joys.digital',
    '37084624': 'https://testnet.skalenodes.com/v1/lanky-ill-funny-testnet',
    '39916801': 'https://kingdomchain.observer/rpc',
    '43214913':
        'http://174.138.9.169:9650/ext/bc/VUKSzFZKckx4PoZF9gX5QAqLPxbLzvu1vcssPG5QuodaJtdHT/rpc',
    '50591822': 'https://rpc.stavanger.gateway.fm',
    '52027071': 'https://rpc.devianttoken.net',
    '52027080': 'https://trpc.devianttoken.net',
    '52164803': 'https://rpc.testnet.fluence.dev/',
    '61717561': 'https://c.onical.org',
    '65100004': 'https://autonity.rpc.web3cdn.network/testnet',
    '68840142': 'https://rpc.testnet.frame.xyz/http',
    '77787778': 'https://rpc-test.0xhash.io',
    '79479957': 'https://rpc.sx-rollup-testnet.t.raas.gelato.cloud',
    '88558801': 'https://testnet.rpc.backstop.technology',
    '88888888': 'https://rpc.teamblockchain.team',
    '89346162': 'https://rpc.reya-cronos.gelato.digital',
    '94204209': 'https://rpc.polygon-blackberry.gelato.digital',
    '97912060': 'https://rpc.chadchain.org',
    '99415706': 'https://toys.joys.cash/',
    '100000000': 'https://rpc.ethos.cool',
    '108160679': 'https://evm.orai.io',
    '111557560': 'https://cyber-testnet.alt.technology/',
    '123420111': 'https://rpc.opcelestia-raspberry.gelato.digital',
    '168587773': 'https://sepolia.blast.io',
    '192837465': 'https://mainnet.gather.network',
    '222000222': 'https://testnet-rpc.meld.com',
    '245022926': 'https://devnet.neonevm.org',
    '245022929': 'https://devnet.rollup.neonevm.org/',
    '245022934': 'https://neon-proxy-mainnet.solana.p2p.org',
    '245022940': 'https://testnet.neonevm.org',
    '253368190': 'https://rpc.flame.astria.org',
    '278611351': 'https://mainnet.skalenodes.com/v1/turbulent-unique-scheat',
    '311752642': 'https://mainnet-rpc.oneledger.network',
    '328527624': 'https://testnet-rpc.nal.network',
    '333000333': 'https://rpc-1.meld.com',
    '344106930': 'https://staging-v3.skalenodes.com/v1/staging-utter-unripe-menkar',
    '356256156': 'https://testnet.gather.network',
    '420420421': 'https://westend-asset-hub-eth-rpc.polkadot.io',
    '476158412': 'https://staging-v3.skalenodes.com/v1/staging-legal-crazy-castor',
    '476462898': 'https://skopje-rpc.gptprotocol.io',
    '486217935': 'https://devnet.gather.network',
    '503129905': 'https://staging-v3.skalenodes.com/v1/staging-faint-slimy-achird',
    '531050104': 'https://rpc.testnet.sophon.xyz',
    '666666666': 'https://rpc.degen.tips',
    '728126428': 'https://rpc.ankr.com/tron_jsonrpc',
    '888888888': 'https://rpc.ancient8.gg',
    '889910245': 'https://rpc-testnet.ptcscan.io',
    '889910246': 'https://rpc.ptcscan.io',
    '974399131': 'https://testnet.skalenodes.com/v1/giant-half-dual-testnet',
    '994873017': 'https://mainnet-rpc.lumia.org',
    '999999999': 'https://sepolia.rpc.zora.energy',
    '1020352220': 'https://testnet.skalenodes.com/v1/aware-fake-trim-testnet',
    '1122334455': 'https://rpc.iposlab.com',
    '1146703430': 'http://cybeth1.cyberdeck.eu:8545',
    '1273227453': 'https://mainnet.skalenodes.com/v1/wan-red-ain',
    '1278060416': 'https://rpc.official-vasyl.network',
    '1313161554': 'https://mainnet.aurora.dev',
    '1313161555': 'https://testnet.aurora.dev/',
    '1313161560': 'https://powergold.aurora.dev',
    '1313161567': 'https://rpc-0x4e45415f.aurora-cloud.dev',
    '1350216234': 'https://mainnet.skalenodes.com/v1/parallel-stormy-spica',
    '1351057110': 'https://staging-v3.skalenodes.com/v1/staging-fast-active-bellatrix',
    '1380012617': 'https://rari.calderachain.xyz/http',
    '1380996178': 'https://rpc.raptorchain.io/web3',
    '1444673419': 'https://testnet.skalenodes.com/v1/juicy-low-small-testnet',
    '1482601649': 'https://mainnet.skalenodes.com/v1/green-giddy-denebola',
    '1511670449': 'https://rpc.gptprotocol.io',
    '1517929550': 'https://staging-v3.skalenodes.com/v1/staging-aware-chief-gianfar',
    '1523903251': 'https://rpc-testnet.haust.app',
    '1564830818': 'https://mainnet.skalenodes.com/v1/honorable-steel-rasalhague',
    '1570754601': 'https://rpc-test.haust.network',
    '1666600000': 'https://api.harmony.one',
    '1666600001': 'https://api.s1.t.hmny.io',
    '1666600002': 'https://api.s2.t.hmny.io',
    '1666600003': 'https://api.s3.t.hmny.io',
    '1666700000': 'https://api.s0.b.hmny.io',
    '1666700001': 'https://api.s1.b.hmny.io',
    '1666900000': 'https://api.s0.ps.hmny.io',
    '1666900001': 'https://api.s1.ps.hmny.io',
    '1722641160': 'https://rpc-sepolia.silicon.network',
    '1903648807': 'https://gemutest-rpc.gemuchain.io',
    '1918988905': 'https://testnet.rpc.rarichain.org/http',
    '1952959480': 'https://testnet-rpc.lumia.org',
    '2021121117': 'https://23.92.21.121:8545',
    '2046399126': 'https://mainnet.skalenodes.com/v1/elated-tan-skat',
    '2478899481': 'https://kermit.accumulatenetwork.io/eth',
    '2863311531': 'https://rpc-testnet.ancient8.gg',
    '3125659152': 'https://wallrpc.pirl.io',
    '4216137055': 'https://frankenstein-rpc.oneledger.network',
    '7078815900': 'https://rpc.mekong.ethpandaops.io',
    '11297108099': 'https://palm-testnet.infura.io/v3/${INFURA_API_KEY}',
    '11297108109': 'https://palm-mainnet.infura.io/v3/${INFURA_API_KEY}',
    '28872323069': 'https://testnet.gitswarm.com:2096',
    '37714555429': 'https://testnet-v2.xai-chain.net/rpc',
    '44474237230': 'https://rpc.dev.deriw.com',
    '88153591557': 'https://rpc.arb-blueberry.gelato.digital',
    '111222333444': 'https://londonpublic.alphabetnetwork.org',
    '111551119090': 'https://rpc.thanos-sepolia.tokamak.network',
    '123420000220': 'https://rpc.stage.fluence.dev',
    '123420000558': 'https://rpc.pin.t.raas.gelato.cloud',
    '123420000586': 'https://rpc.sivo-defi-testnet.t.raas.gelato.cloud',
    '123420000588': 'https://rpc.volmex.t.raas.gelato.cloud',
    '197710212030': 'https://rpc.ntity.io',
    '197710212031': 'https://blockchain.haradev.com',
    '202402181627': 'https://gmnetwork-testnet.alt.technology/',
    '383414847825': 'https://api.zeniq.network',
    '666301171999': 'https://mainnet.ipdc.io/',
    '6022140761023': 'https://molereum.jdubedition.com',
    '16604737732183': 'https://rpc.flame.dawn-1.astria.org',
    '868455272153094': 'https://godwoken-testnet-web3-v1-rpc.ckbapp.dev',
    '920637907288165': 'https://sepolia-rpc.kakarot.org',
    '2713017997578000': 'https://dchaintestnet-2713017997578000-1.jsonrpc.testnet.sagarpc.io',
    '2716446429837000': 'https://dchain-2716446429837000-1.jsonrpc.sagarpc.io',
}

export const ApiKey = '1234321'

export const MULTICALL_ADDRESSES = {
    '300': '0xFc171fC6CD955aBb1f7724DdAA4E85c89000C5ac',
    '324': '0x47898B2C52C957663aE9AB46922dCec150a2272c',
}
